import { Component, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { addDays, format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { RadialGauge, LinearGauge } from 'canvas-gauges';
import { Chart } from 'chart.js/auto';
import { FormControl, FormGroup } from '@angular/forms';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Error429Service } from 'src/app/services/error429.service';
import { environment } from "./../../../../environments/environment";
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UserDataService } from 'src/app/services/user-data.service';
import { ToastrService } from 'ngx-toastr';
import { MapService } from 'src/app/services/map.service';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import { CircularFluidMeter, Speed } from 'fluid-meter';

interface Escala {
  value: string;
  viewValue: string;
}
interface DatosTanque {
  deviceId: number;
  slot: number;
  consumo: number;
}

@Component({
  selector: 'app-ver-establecimiento-completo',
  templateUrl: './ver-establecimiento-completo.component.html',
  styleUrls: ['./ver-establecimiento-completo.component.scss']
})
export class VerEstablecimientoCompletoComponent {
  paletaColores = [
    '#1F2A44',  
    '#FBB040', 
    '#42804B', 
    '#5057A6', 
    '#AB2924', 
    '#3591CF', 
    '#895881', 
    '#6DC38F', 
    '#C39648', 
    '#81A1C1', 
    '#A8724E',
    '#31AEC9' 
  ];

  paletaGrises = [
    '#616161',  
    '#757575',  
    '#9E9E9E',  
    '#BDBDBD',  
    '#E0E0E0', 
    '#212121',  
    '#424242',  
    '#B0BEC5',  
    '#78909C',  
    '#CFD8DC'   
  ];

  paletaNaranjas = [
    '#FF6F00',  // Naranja oscuro
    '#BDBDBD',  // Gris claro
    '#FF8C00',  // Naranja
    '#9E9E9E',  // Gris medio
    '#FF9F00',  // Naranja suave
    '#757575',  // Gris oscuro
    '#FFB74D',  // Naranja claro
    '#FFC107',  // Amarillo anaranjado
    '#616161',  // Gris más oscuro
    '#FF5722',  // Naranja rojizo
    '#424242',  // Gris casi negro
    '#FF3D00'   // Rojo anaranjado brillante
  ];

  userDevices: any = []; //Información básica los clientes
  establishmentData: any = []; //Información de los establecimientos
  alarmas: any = [];
  alarmasActivadas: any = [];
  deviceHistoryMap: { [deviceReference: string]: any } = {}; //Historial de los dispositivos
  errorMessage: string = ""; //Mensaje de error
  urlMap: any; //url del mapa
  currentPath: string = ""; //Ruta actual
  dev_reference: string = "";
  dev_label: string = "";
  dev_id: string = "";
  dev_create_at: string = "";
  activado: boolean = false; //Dispositivo activado 
  dev_img: string = ""; //Imagen del dispositivo
  dev_img_path: string = "";
  lat: number = 43.0081016;
  lng: number = -7.5561412;
  zoom: number = 10;
  //Datos del último histórico
  fechaDelUltimoHistorico: string = "";
  temperaturaAmbiente: string = "";
  nivelT1: string = "0";
  nivelT2: string = "0";
  nivelT3: string = "0";
  nivelT4: string = "0";
  temperaturaT1: string = "0";
  temperaturaT2: string = "0";
  temperaturaT3: string = "0";
  temperaturaT4: string = "0";
  presionT1: string = "0";
  presionT2: string = "0";
  presionT3: string = "0";
  presionT4: string = "0";
  capacidadT1: string = "0";
  capacidadT2: string = "0";
  capacidadT3: string = "0";
  capacidadT4: string = "0";
  consumidosT1: string = "0.0";
  consumidosT2: string = "0.0";
  consumidosT3: string = "0.0";
  consumidosT4: string = "0.0";
  tipoCervezaT1: string = "";
  tipoCervezaT2: string = "";
  tipoCervezaT3: string = "";
  tipoCervezaT4: string = "";
  imagenCervezaT1: string = "";
  imagenCervezaT2: string = "";
  imagenCervezaT3: string = "";
  imagenCervezaT4: string = "";
  imagenCervezaT1Url: string = "";
  imagenCervezaT2Url: string = "";
  imagenCervezaT3Url: string = "";
  imagenCervezaT4Url: string = "";
  numeroTanque1: string = "";
  numeroTanque2: string = "";
  numeroTanque3: string = "";
  numeroTanque4: string = "";
  datosRecibidos1: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  alarmRangesTanks: any[] = [];
  displayedColumns: string[] = ['deviceLabel','f_inicio', 'f_fin', 'valorAlarma', 'type', 'rango'];
  displayedColumnsActivas: string[] = ['deviceLabel', 'f_inicio', 'type', 'valorAlarma', 'rango'];
  charts: any[] = []; //Información de los charts para poder eliminarlos
  // Condición para ver si el borde de la imagen es verde
  condicionT1Activo: boolean = false;
  condicionT2Activo: boolean = false;
  condicionT3Activo: boolean = false;
  condicionT4Activo: boolean = false;
  // Condición para mostrar o no el tanque
  verT1: boolean = false;
  verT2: boolean = false;
  verT3: boolean = false;
  verT4: boolean = false;
  //Colores de las gráficas
  gradientStroke: any;
  gradientStroke2: any;
  gradientStroke3: any;
  gradientFill: any;
  gradientFill2: any;
  gradientFill3: any;

  //GRAFICAS CARGADAS
  fechaCambiadaGraficasCargardas: boolean = false;

  //ESTADISTICAS
  datosEstadisticosTemperatura: any = [];
  datosEstadisticosTemperaturaTodos: any = [];
  datosEstadisticosPresion: any = [];
  datosEstadisticosPresionTodos: any = [];
  datosEstadisticosNivel: any = [];
  datosEstadisticosConsumo: any = [];
  datosEstadisticosConsumoTodos: any = [];
  panelEstadisticasAbierto: boolean = false;

  //NO HAY DATOS
  graficasDatos: boolean = true;
  mensajeNoHayDatos: string = "(No hay datos disponibles en las fechas seleccionadas)";

  //DINAMICO
  tanksInfo: any[] = [];
  gaugesCargados: boolean = false;

  idIncorrectoError: boolean = false;
  stringTitulosTiempo: string = "Fecha (Día/Mes/Año HH:mm)";
  dispositivoId: any = [];
  dispostivoData: any = [];
  hayAlarmas: boolean = false;
  hayAlarmasActivadas: boolean = false;
  hayAlarmasDesactivadas: boolean = false;
  numeroAlarmasActivadas: number = 0;
  diferenciaDias: number = 0;

  // ESTABLECIMIENTO COMPLETO
  establecimientoActual: any = [];
  dispositivosEnEstablecimientoActual: any = [];
  tanquesEnEstablecimientoActual: any[] = [];
  tanquesEnEstablecimientoOriginal: any[] = [];
  devicesReferences: string = "";
  litrosConsumidosPorTanque: DatosTanque[] = [];
  establecimientos: any = [];

  // CONSUMO DIA ACTUAL
  consumoDiaActual: any = [];
  historicosEnTanques: any = [];
  historicosEnDispositivo: any = [];
  fechaUltimoHistorico: string | null = "";
  temperaturaAmbienteActual: string | null = "";

  // PEDIDOS Y RECARGAS
  pedidos: any = [];
  recargas: any = [];

  // LLAMADAS 
  llamarOptimizada: boolean = false;

  // GRAFICAS
  spanGaps: number = 1250 * 60 * 60;
  escalaDias: boolean = false;
  diaActualIncluido: boolean = true;
  readersRawDiaActual: any = [];

  // ALARMAS
  alarmasDesconexion:any;
  alarmasConOO: any;

  /*-------------------------------FechaActualConGuiones------------------------------------------*/
  fechaActualD = new Date();
  fechaActual: Date = new Date();
  dia: number = this.fechaActual.getDate(); // Obtener el día del mes actual
  mes: number = this.fechaActual.getMonth(); // Los meses comienzan en 0, por lo que enero es 0 y diciembre es 11)
  anio: number = this.fechaActual.getFullYear(); // Obtener el año actual
  mes1 = this.mes + 1; // Los meses comienzan desde 0, por lo que se suma 1
  fechaFormateada = `${this.anio}-${this.mes1.toString().padStart(2, '0')}-${this.dia.toString().padStart(2, '0')}`;
  fechaFormateadaDiaSiguiente = `${this.anio}-${this.mes1.toString().padStart(2, '0')}-${(this.dia + 1).toString().padStart(2, '0')}`;
  /*-------------------------------FechaActualConGuiones------------------------------------------*/

  /*-------------------------------Suscripciones------------------------------------------*/
  private establishmentSubscription: Subscription | undefined;
  private alarmsSubscription: Subscription | undefined;
  private historialSubscription: Subscription | undefined;
  private historialRawSubscription: Subscription | undefined;
  private establishment1Subscription: Subscription | undefined;
  private tanksSubscription: Subscription | undefined;
  private beersSubscription: Subscription | undefined;
  private agregarPedidoSubscription: Subscription | undefined;
  private historicoDiaSubscription: Subscription | undefined;
  private establecimientosSubscription: Subscription | undefined;
  private pedidosSubscription: Subscription | undefined;
  private recargasSubscription: Subscription | undefined;

  /*-------------------------------Seleccionar fecha para los gráficos------------------------------------------*/
  selectedDate = new FormGroup({
    start: new FormControl(new Date(this.anio, this.mes, this.dia)),
    end: new FormControl(new Date(this.anio, this.mes, this.dia)),
  });
  /*-------------------------------Seleccionar escala para los gráficos------------------------------------------*/
  selectedValue: string = "5";
  escalas: Escala[] = [
    { value: '5', viewValue: 'Mínima' },
    { value: '15', viewValue: '15 minutos' },
    { value: '30', viewValue: '30 minutos' },
    { value: '60', viewValue: '60 minutos' },
  ];
  urlBase: string = "";

  //TABLA TANQUES
  displayedColumnsTanques: string[] = ['nombreTanque', 'numero', 'espacio', 'cerveza', 'capacidad', 'operaciones'];
  dataSource: any;
  dataSourceAlarms: any;
  dataSourceAlarmsActivas: any;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('paginator1') paginator1!: MatPaginator;
  tanksData: any;
  tablaData: any[] = [];
  beersData: any;
  map: any;
  marker: any;

  //ACTUALIZAR DATOS
  intervalId: any;
  tamañoHistorOriginal: number = 0;
  chartT: any;
  chartP: any;
  chartNC: any;
  gaugeNivel: any;
  gaugeTemperatura: any;
  gaugePresion: any;
  gaugesLista: any = [];

  @ViewChild('sort1') sort1!: MatSort;
  @ViewChild('sort2') sort2!: MatSort;
  @ViewChild('sort3') sort3!: MatSort;

  userServiceData: any = [];
  actualizar: boolean = false;
  waitAfterSave: boolean = false;
  recargarGrafica: boolean = false;

  constructor(private deviceService: DeviceService, private sanitizer: DomSanitizer, private router: Router,
    private error429: Error429Service, private userDataService: UserDataService,
    private toastr: ToastrService, private mapService: MapService) {
    this.currentPath = this.router.url;
    this.dispositivoId.push(this.getDeviceIdFromPath(this.currentPath));
    this.urlBase = environment.urlNonce;
    this.userServiceData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    const fechaOriginal = new Date(this.fechaFormateada);
    const fechaSumada = new Date(fechaOriginal);
    fechaSumada.setDate(fechaOriginal.getDate() + 1);
    //this.getDevicesData(this.fechaFormateada, fechaSumada.toISOString().split("T")[0], this.selectedValue, recargarGafica, actualizar);
    this.getDatos(this.fechaFormateada, fechaSumada.toISOString().split("T")[0], this.actualizar);
    //Actualizar los datos cada 60 segundos
    this.intervalId = setInterval(() => {
      const start = this.convertirFechaInicioParaApi();
      const end = this.convertirFechaFinParaApi();
      const fechaOriginal = new Date(end);
      const fechaSumada = new Date(fechaOriginal);
      //Los gráficas de la consulta de históricos solo se recargan si el día de hoy está incluido
      if (this.isFechaFormateadaInRange(start, fechaSumada.toISOString().split("T")[0])) {
        this.recargarGrafica = true;
        //this.fechaCambiadaGraficasCargardas = false;
      } else {
        this.recargarGrafica = false;
      }
      fechaSumada.setDate(fechaOriginal.getDate() + 1);
      //Se mantiene la fecha y la escala si se han cambiado para las gráficas
      this.actualizar = true;
      //this.getDevicesData(start, fechaSumada.toISOString().split("T")[0], this.selectedValue, recargarGafica, actualizar);
      this.getDatos(start, fechaSumada.toISOString().split("T")[0], this.actualizar);
      //console.log("15 seg")
    }, 15000)
  }

  isFechaFormateadaInRange(start: string, end: string): boolean {
    const fechaFormateada = new Date(this.fechaFormateada);
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Ajusta las fechas para ignorar la hora exacta
    fechaFormateada.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    return fechaFormateada >= startDate && fechaFormateada <= endDate;
  }

  manejarCierrePanel(): void {
    this.panelEstadisticasAbierto = false;
  }

  manejarAperturaPanel(): void {
    this.panelEstadisticasAbierto = true;
  }

  async getDatos(chartStart: string, chartEnd: string, actualizar: boolean) {
    this.alarmas = [];
    this.alarmasActivadas = [];
    this.tablaData = [];
    if (!actualizar) {
      this.beersSubscription = this.deviceService.getBeerType().subscribe({
        next: resp => {
          this.beersData = resp;
        }, error: err => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: async () => {
          await this.conseguirInformacionEstablecimientoActual(chartStart, chartEnd);
          //console.log("ESTABLECIMIENTOS",this.establecimientoActual);
          //console.log("DISPOSITIVOS",this.dispositivosEnEstablecimientoActual);
          //console.log(this.tanquesEnEstablecimientoActual);
          //console.log("CERVEZAS",this.beersData);
          //console.log("CONSUMO DEL DIA",this.consumoDiaActual);
        }
      });
    } else {
      await this.conseguirInformacionEstablecimientoActual(chartStart, chartEnd);
    }
  }

  existeAlarmaConTypeSymbol(tankID: number, typeSymbol: string): boolean {
    const alarmaTanque = this.alarmasActivadas.some((alarma: any) => alarma.tankID === tankID && alarma.type_symbol === typeSymbol);
    return alarmaTanque;
  }

  soloDosDecimalesConString(cadena: string | null) {
    let numero;
    if (cadena) {
      numero = parseFloat(cadena);
      if (Number.isNaN(numero)) {
        return "--"
      } else {
        return numero.toLocaleString(this.userServiceData.region, { minimumFractionDigits: 1, maximumFractionDigits: 2 });
      }
    } else {
      return '--';
    }
  }

  sinDecimales(cadena: any) {
    let numero;
    if (cadena) {
      numero = parseFloat(cadena);
      if (Number.isNaN(numero)) {
        return "--"
      } else {
        return Math.floor(numero).toLocaleString(this.userServiceData.region);
      }
    } else {
      return '--';
    }
  }

  getNivelFormatted(id: number, slot: number, dispositivo: any): string {
    const nivel = this.devolverNivel(id, slot, dispositivo);
    const nivelNumero = parseFloat(nivel);
    
    if (isNaN(nivelNumero)) {
      return '0';
    }
  
    return nivelNumero < 0 ? '0' : this.sinDecimales(nivelNumero);
  }

  soloDosDecimalesConComa(numero: number) {
    if (Number.isNaN(numero)) {
      return 0
    } else {
      return numero.toLocaleString(this.userServiceData.region, { maximumFractionDigits: 2 });
    }
  }

  obtenerNombreCerveza(id: number): string {
    const cerveza = this.beersData.find((beer: any) => beer && beer.id === id);
    return cerveza ? cerveza.name : 'Cerveza no encontrada';
  }

  obtenerImagenCerveza(id: number): string {
    const cerveza = this.beersData.find((beer: any) => beer && beer.id === id);
    return cerveza ? cerveza.img : 'Cerveza no encontrada';
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    }
    if (this.alarmsSubscription) {
      this.alarmsSubscription.unsubscribe();
    }
    if (this.historialSubscription) {
      this.historialSubscription.unsubscribe();
    }
    if (this.establishment1Subscription) {
      this.establishment1Subscription.unsubscribe();
    }
    if (this.tanksSubscription) {
      this.tanksSubscription.unsubscribe();
    }
    if (this.beersSubscription) {
      this.beersSubscription.unsubscribe();
    }
    if (this.agregarPedidoSubscription) {
      this.agregarPedidoSubscription.unsubscribe();
    }
    if (this.historicoDiaSubscription) {
      this.historicoDiaSubscription.unsubscribe();
    }
    if (this.establecimientosSubscription) {
      this.establecimientosSubscription.unsubscribe();
    }
    if (this.pedidosSubscription) {
      this.pedidosSubscription.unsubscribe();
    }
    if (this.recargasSubscription) {
      this.recargasSubscription.unsubscribe();
    }
    if (this.historialRawSubscription) {
      this.historialRawSubscription.unsubscribe();
    }
    clearInterval(this.intervalId);
    Chart.unregister(zoomPlugin);
    this.destroyCharts();
    this.destroyGauges();
    //location.reload(); 
  }

  getNewGraphicDate() {
    const start = this.convertirFechaInicioParaApi();
    const end = this.convertirFechaFinParaApi();
    if (start !== "Fecha de inicio no seleccionada" && end !== "Fecha fin no seleccionada") {
      this.graficasDatos = true;
      this.fechaCambiadaGraficasCargardas = false;
      const fechaOriginal = new Date(end);
      const fechaSumada = new Date(fechaOriginal);
      //Sumarle uno a la fecha end para que devuelva bien los datos la api
      fechaSumada.setDate(fechaOriginal.getDate() + 1);
      this.loadChartsCompleto(start, fechaSumada.toISOString().split("T")[0]);
    } else {
      this.destroyCharts();
      this.graficasDatos = false;
      this.mensajeNoHayDatos = "(Selecciona una fecha correcta)";
    }
  }

  devolverUltimaLecturaFormateada(fecha: string | null): string {
    if (!fecha || fecha == "--") {
      return 'No hay datos registrados todavía';
    }
    return format(new Date(fecha), 'dd-MM-yyyy HH:mm:ss');
  }

  descargarExcel(): void {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'Establecimiento', key: 'establecimiento', width: 20 },
      { header: 'Dispositivo', key: 'dev_label', width: 20 },
      { header: 'Ref. Dispositivo', key: 'dev_reference', width: 15 },
      { header: 'Fecha', key: 'formattedDate', width: 20 },
      //{ header: 'Tensión Eléctrica', key: 'field1', width: 17 },
      { header: 'Tanque Activo', key: 'field2', width: 15 },
      { header: 'Presión Tanque 1', key: 'field3', width: 17 },
      { header: 'Presión Tanque 2', key: 'field4', width: 17 },
      { header: 'Presión Tanque 3', key: 'field5', width: 17 },
      { header: 'Presión Tanque 4', key: 'field23', width: 17 },
      { header: 'Temperatura Tanque 1', key: 'field6', width: 20 },
      { header: 'Temperatura Tanque 2', key: 'field7', width: 20 },
      { header: 'Temperatura Tanque 3', key: 'field8', width: 20 },
      { header: 'Temperatura Tanque 4', key: 'field24', width: 20 },
      { header: 'Temperatura Exterior', key: 'field9', width: 15 },
      //{ header: 'Sensor Extra', key: 'field10', width: 15 },
      { header: 'Caudal 1 Tanque 1', key: 'field11', width: 20 },
      { header: 'Caudal 2 Tanque 1', key: 'field12', width: 20 },
      { header: 'Caudal 3 Tanque 1', key: 'field20', width: 20 },
      { header: 'Caudal 1 Tanque 2', key: 'field13', width: 20 },
      { header: 'Caudal 2 Tanque 2', key: 'field14', width: 20 },
      { header: 'Caudal 3 Tanque 2', key: 'field21', width: 20 },
      { header: 'Caudal 1 Tanque 3', key: 'field15', width: 20 },
      { header: 'Caudal 2 Tanque 3', key: 'field16', width: 20 },
      { header: 'Caudal 3 Tanque 3', key: 'field22', width: 20 },
      { header: 'Caudal 1 Tanque 4', key: 'field26', width: 20 },
      { header: 'Caudal 2 Tanque 4', key: 'field27', width: 20 },
      { header: 'Caudal 3 Tanque 4', key: 'field28', width: 20 },
      { header: 'Nivel Tanque 1', key: 'field17', width: 15 },
      { header: 'Nivel Tanque 2', key: 'field18', width: 15 },
      { header: 'Nivel Tanque 3', key: 'field19', width: 15 },
      { header: 'Nivel Tanque 4', key: 'field25', width: 15 },
    ];

    // Estilo para recalcar las columnas
    const negritaEstilo: Partial<ExcelJS.Style> = {
      font: {
        bold: true,
      },
    };
    worksheet.getColumn('dev_label').style = negritaEstilo;
    worksheet.getColumn('dev_reference').style = negritaEstilo;

    // Agregar los datos a las filas del archivo de Excel
    this.historicosEnDispositivo.forEach((dispositivo: any) => {
      for (let i = 0; i < dispositivo.readers_raw.length; i++) {
        const formattedDate = format(new Date(dispositivo.readers_raw[i].created_at), 'dd-MM-yyyy HH:mm:ss',);
        const rowData = {
          establecimiento: this.establecimientoActual.est_name,
          formattedDate: formattedDate,
          ...dispositivo.readers_raw[i],  // Ajusta cómo se combinan los datos
          ...dispositivo,
        };
        console.log(rowData);
        worksheet.addRow(rowData);
      }
    });

    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const start = this.convertirFechaInicioParaApi();
      const end = this.convertirFechaFinParaApi();
      if (start == end) {
        saveAs(blob, this.establecimientoActual.est_name + "_Fecha_" + start + "_lecturas.xlsx");
      } else {
        saveAs(blob, this.establecimientoActual.est_name + "_Fecha_De_:" + start + "_Hasta_:" + end + "_lecturas.xlsx");
      }
    });
  }

  destroyCharts() {
    Object.values(this.charts).forEach((chart) => {
      chart.destroy();
    });
    this.charts = [];
  }

  convertirFechaInicioParaApi(): string {
    if (this.selectedDate.value.start) {
      const fecha = new Date(this.selectedDate.value.start);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }
    return "Fecha de inicio no seleccionada";
  }

  convertirFechaFinParaApi(): string {
    if (this.selectedDate.value.end) {
      const fecha = new Date(this.selectedDate.value.end);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${year}-${month}-${day}`;
      return fechaFormateada;
    }
    return "Fecha fin no seleccionada";
  }

  getDeviceIdFromPath(path: string): number {
    const parts = path.split('/');
    const lastPart = parts[parts.length - 1];
    const lastNumber = parseInt(lastPart, 10);
    return lastNumber;
  }

  async initMap(): Promise<void> {
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: false,
        title: 'Marcador'
      });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  convertirFecha(fecha: string): string {
    const fechaParseada = parseISO(fecha);
    const fechaFormateada = format(fechaParseada, "EEEE, d 'de' MMMM 'de' yyyy HH:mm", { locale: es });
    return fechaFormateada;
  }

  conseguirHoraEnFecha(fecha: string): string {
    const dateTimeString = fecha;
    const dateObj = new Date(dateTimeString);
    const hour = dateObj.getHours().toString().padStart(2, '0');
    const minute = dateObj.getMinutes().toString().padStart(2, '0');
    //const second = dateObj.getSeconds().toString().padStart(2, '0'); // Agrega ceros al principio si es necesario
    const timeString = `${hour}:${minute}`;
    return timeString;
  }

  quitarAnioYMesSiMismoAnioYMes(fechas: string[], start: string, end: string): string[] {
    const mismoAnioMesStart = start.substring(0, 7) === end.substring(0, 7);
    const mismoAnioStart = start.substring(0, 4) === end.substring(0, 4);
    if (mismoAnioMesStart) {
      if (fechas[0].length == 5) {
        /*Si el start y el end es el mismo día la respuesta devuelve la fecha en 
        formato HH:MM y no hay que cambiar nada solo el titulo*/
        this.stringTitulosTiempo = "Fecha (HH:mm)";
      } else {
        this.stringTitulosTiempo = "Fecha (Día HH:mm)";
        fechas = fechas.map(fecha => fecha.substring(8));
      }
    } else if (mismoAnioStart) {
      this.stringTitulosTiempo = "Fecha (Mes-Día HH:mm)";
      fechas = fechas.map(fecha => fecha.substring(5));
    } else {
      this.stringTitulosTiempo = "Fecha (Año-Mes-Día HH:mm)";
    }
    return fechas;
  }

  calcularMajorTicks(minValue: number | null, maxValue: number | null, intervalo: number, defaultMax: number, valorActualTanque: number | null): number[] {
    // Calcular el valor más alto entre maxValue, valorActualTanque, y defaultMax
    let maxTick = defaultMax;
    if (maxValue !== null) {
      maxTick = maxValue;
    }
    if (valorActualTanque !== null) {
      maxTick = Math.max(maxTick, valorActualTanque);
    }
    // Calcular el valor más bajo entre minValue y valorActualTanque
    let minTick = 0;
    if (minValue !== null) {
      minTick = minValue;
    }
    if (valorActualTanque !== null) {
      minTick = Math.min(minTick, valorActualTanque);
    }
    // Calcular la diferencia entre el tick más bajo y el más alto
    const difference = maxTick - minTick;

    if (isNaN(Number(maxTick))) {
      maxTick = defaultMax;
    }

    if (isNaN(Number(minTick))) {
      minTick = 0;
    }

    maxTick = maxTick + 1;
    minTick = minTick - 1

    // Calcular el intervalo basado en la diferencia
    if (intervalo == 0) {
      intervalo = Math.max(Math.floor(difference / 10), 1);
    }

    // Calcular los ticks mayores
    const result: number[] = [];
    for (let i = minTick; i <= maxTick; i += intervalo) {
      result.push(parseFloat(i.toFixed(2)));
    }
    return result;
  }

  // ESTABLECIMIENTO COMPLETO

  conseguirInformacionEstablecimientoActual(chartStart: string, chartEnd: string) {
    return new Promise<void>((resolve, reject) => {
      const establecimientoId = this.getDeviceIdFromPath(this.currentPath);
      this.establishmentSubscription = this.deviceService.getEstablishmentDataNew(establecimientoId).subscribe({
        next: resp => {
          //this.establecimientoActual = resp;
          this.establecimientoActual = resp;
          console.log("this.establecimientoActual", this.establecimientoActual);
          if (this.establecimientoActual.devices.length > 1) {
            this.displayedColumnsActivas = ['deviceLabel', 'f_inicio', 'type', 'valorAlarma', 'rango'];
            this.displayedColumns =  ['deviceLabel','f_inicio', 'f_fin', 'valorAlarma', 'type', 'rango'];
          } else {
            this.displayedColumnsActivas = ['f_inicio', 'type', 'valorAlarma', 'rango'];
            this.displayedColumns =  ['f_inicio', 'f_fin', 'valorAlarma', 'type', 'rango'];
          }
        }, error: err => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete: async () => {
          await this.calcularConsumoDiaActual();
          await this.calcularAlarmasEstablecimiento();

          this.dispositivosEnEstablecimientoActual = this.establecimientoActual.devices;
          this.establecimientoActual.ultimaLectura = this.devolverUltimaLecturaEstablecimiento();
          this.establecimientoActual.listaUltimaLectura = this.devolverUltimaLecturaEstablecimientoArray();
          this.establecimientoActual.temperaturaAmbiente = this.devolverUltimaLecturaTemperaturaAmbiente();
          this.obtenerTemperaturaAmbienteYLecturaMasAntiguaDeLaLecturaMasAntigua(this.historicosEnDispositivo);

          // DATOS RECIBIDOS
          this.datosRecibidos1 = true;

          // Hacer solo cuando se carga por primera vez la página
          if (!this.actualizar) {
            this.calcularTanquesEnEstablecimientoActual();

            // Necesario enseñar el html para que los gauges tengan un id con el que renderizarse
            for (let i = 0; i < this.tanquesEnEstablecimientoActual.length; i++) {
              this.cargarGuage(this.tanquesEnEstablecimientoActual[i].id);
            }
            this.gaugesCargados = true;

            // CARGAR GRÁFICAS
            this.loadChartsCompleto(chartStart, chartEnd);

            // CARGAR MAPA
            setTimeout(() => {
              this.lat = this.establecimientoActual.est_lat;
              this.lng = this.establecimientoActual.est_lng;
              this.mapService.loadMapScript(this.initMap.bind(this));
            }, 0);

          } else {
            // Actualzar la lista de objetos sin actualizar el DOM y que los gauges no desaparezcan
            for (let i = 0; i < this.tanquesEnEstablecimientoActual.length; i++) {
              const id = this.tanquesEnEstablecimientoActual[i].id;
              const tanqueActualizado = this.calcularTanquesEnEstablecimientoActualActualizacion().find((tanque: any) => tanque.id === id);
              if (tanqueActualizado) {
                Object.assign(this.tanquesEnEstablecimientoActual[i], tanqueActualizado);
              }
            }
            //console.log("Tanques",  this.tanquesEnEstablecimientoActual);

            // Actualizar si un tanque necesita recarga y el resto de datos
            for (let i = 0; i < this.tanquesEnEstablecimientoActual.length; i++) {
              this.actualizarGauges(this.tanquesEnEstablecimientoActual[i].id);
              this.tanquesEnEstablecimientoActual[i].recargaNecesaria = this.existeAlarmaConTypeSymbol(this.tanquesEnEstablecimientoActual[i].id, "L" + this.tanquesEnEstablecimientoActual[i].slot)
            }

            // Actualizar siempre los datos de los historicos para calcular el consumo actual
            this.actualizarTodayCharts(chartStart, chartEnd);
          }

          for (let i = 0; i < this.tanquesEnEstablecimientoActual.length; i++) {
            const tankData: any = {
              id: this.tanquesEnEstablecimientoActual[i].id,
              nombreTanque: this.tanquesEnEstablecimientoActual[i].external_id,
              espacio: this.tanquesEnEstablecimientoActual[i].slot,
              numero: this.tanquesEnEstablecimientoActual[i].custom_num,
              cerveza: this.obtenerNombreCerveza(this.tanquesEnEstablecimientoActual[i].beer_type_id),
              capacidad: this.tanquesEnEstablecimientoActual[i].capacity,
            }
            this.tablaData.push(tankData);
          }
          this.dataSource = new MatTableDataSource(this.tablaData);
          this.dataSource.sort = this.sort1;

          //this.calcularDevicesIds([this.establecimientoActual]);
          resolve();
        }
      });
    });
  }

  calcularTanquesEnEstablecimientoActual() {
    const tanques: any = [];
    for (let i = 0; i < this.establecimientoActual.devices.length; i++) {
      for (let j = 0; j < this.establecimientoActual.devices[i].tanks.length; j++) {
        tanques.push(this.establecimientoActual.devices[i].tanks[j]);
      }
    }
    for (let i = 0; i < tanques.length; i++) {
      tanques[i].cerveza = this.devolverCerveza(tanques[i].beer_type_id)
      tanques[i].consumoDelDia = this.devolverConsumoEnTanque(tanques[i].device_id, tanques[i].slot);
      tanques[i].dispositivo = this.devolverDispositivo(tanques[i].device_id);
    }
    tanques.sort((a: any, b: any) => a.custom_num - b.custom_num);
    // Añadir un campo para indicar si hay una alarma de nivel con ese tanque
    const tanquesConRecarga = tanques.map((tanque: any) => ({
      ...tanque,
      recargaNecesaria: this.existeAlarmaConTypeSymbol(tanque.id, "L" + tanque.slot)  //("L" + tanque.slot)
    }));
    this.tanquesEnEstablecimientoActual = tanquesConRecarga;
  }

  calcularTanquesEnEstablecimientoActualActualizacion() {
    const tanques: any = [];
    for (let i = 0; i < this.establecimientoActual.devices.length; i++) {
      for (let j = 0; j < this.establecimientoActual.devices[i].tanks.length; j++) {
        tanques.push(this.establecimientoActual.devices[i].tanks[j]);
      }
    }
    for (let i = 0; i < tanques.length; i++) {
      tanques[i].cerveza = this.devolverCerveza(tanques[i].beer_type_id)
      tanques[i].consumoDelDia = this.devolverConsumoEnTanque(tanques[i].device_id, tanques[i].slot);
      tanques[i].dispositivo = this.devolverDispositivo(tanques[i].device_id);
      tanques[i].RecargaNecesaria = this.existeAlarmaConTypeSymbol(tanques[i].id, "L" + tanques[i].slot)
    }
    tanques.sort((a: any, b: any) => a.custom_num - b.custom_num);
    return tanques;
  }

  devolverTemperaturaActual() {
    return this.establecimientoActual.ultimaLectura
  }

  calcularAlarmasEstablecimiento() {
    const fechaActualStart = new Date();
    fechaActualStart.setDate(fechaActualStart.getDate() + 1);
    const fechaFormatedaEnd = fechaActualStart.toISOString().split('T')[0];

    const alarmasEstablecimiento = new FormData();
    alarmasEstablecimiento.append('establishments', JSON.stringify([this.establecimientoActual.id]));
    alarmasEstablecimiento.append('start', "2015-01-01");
    alarmasEstablecimiento.append('end', fechaFormatedaEnd);

    return new Promise<void>((resolve, reject) => {
      this.alarmsSubscription = this.deviceService.getAlarmasEstablecimientos(alarmasEstablecimiento).subscribe({
        next: resp => {
          // console.log(resp, 'alarmasEstablecimiento');
          for (let i = 0; i < resp.alarms.length; i++) {
            if (resp.alarms[i].status !== 1) {
              //Alarmas DESACTIVADAS
              const tankJson = JSON.parse(resp.alarms[i].tank);
              const lastReaderJson = JSON.parse(resp.alarms[i].lastreader);
              let alarmRange = "-";
              if (tankJson) {
                const alarmRanges = JSON.parse(tankJson.alarm_ranges);
                if (resp.alarms[i].type == "L1" || resp.alarms[i].type == "L2" || resp.alarms[i].type == "L3" || resp.alarms[i].type == "L4") {
                  alarmRange = "Nivel de cerveza mínimo: " + this.soloDosDecimalesConComa(alarmRanges.beerLevelMin) + "%";
                }
                if (resp.alarms[i].type == "A1" || resp.alarms[i].type == "A2" || resp.alarms[i].type == "A3" || resp.alarms[i].type == "A4") {
                  alarmRange = "Temperatura máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMax) + "ºC";
                }
                if (resp.alarms[i].type == "B1" || resp.alarms[i].type == "B2" || resp.alarms[i].type == "B3" || resp.alarms[i].type == "B4") {
                  alarmRange = "Temperatura mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMin) + "ºC";
                }
                if (resp.alarms[i].type == "C1" || resp.alarms[i].type == "C2" || resp.alarms[i].type == "C3" || resp.alarms[i].type == "C4") {
                  if (alarmRanges.beerPressureMax == 1) {
                    alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bar";
                  } else {
                    alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bares";
                  }
                }
                if (resp.alarms[i].type == "D1" || resp.alarms[i].type == "D2" || resp.alarms[i].type == "D3" || resp.alarms[i].type == "D4") {
                  if (alarmRanges.beerPressureMin == 1) {
                    alarmRange = "Presión mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bar";
                  } else {
                    alarmRange = "Presión mímina: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bares";
                  }
                }
              }
              let type = resp.alarms[i].desc2;
              let valorAlarma = this.deviceService.devolverValorAlarma(resp.alarms[i].type, lastReaderJson, tankJson);
              this.alarmas.push({
                f_inicio: resp.alarms[i].started_at ?? "-",
                f_fin: resp.alarms[i].ended_at ?? "-",
                type: type ?? "-",
                rango: alarmRange,
                valorAlarma: valorAlarma,
                deviceLabel: resp.alarms[i].device.dev_label,
                deviceRef: resp.alarms[i].device.dev_reference
              });
            } else {
              //Alarmas ACTIVADAS
              const tankJson = JSON.parse(resp.alarms[i].tank);
              const lastReaderJson = JSON.parse(resp.alarms[i].lastreader);
              let alarmRange = "-";
              let tankID: any;
              if (tankJson) {
                const alarmRanges = JSON.parse(tankJson.alarm_ranges);
                if (resp.alarms[i].type == "L1" || resp.alarms[i].type == "L2" || resp.alarms[i].type == "L3" || resp.alarms[i].type == "L4") {
                  alarmRange = `Nivel de cerveza mínimo: ${this.soloDosDecimalesConComa(alarmRanges.beerLevelMin)} % = ${this.soloDosDecimalesConComa((alarmRanges.beerLevelMin * tankJson.capacity) / 100)} litros`;
                }
                if (resp.alarms[i].type == "A1" || resp.alarms[i].type == "A2" || resp.alarms[i].type == "A3" || resp.alarms[i].type == "A4") {
                  alarmRange = "Temperatura máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMax) + "ºC";
                }
                if (resp.alarms[i].type == "B1" || resp.alarms[i].type == "B2" || resp.alarms[i].type == "B3" || resp.alarms[i].type == "B4") {
                  alarmRange = "Temperatura mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMin) + "ºC";
                }
                if (resp.alarms[i].type == "C1" || resp.alarms[i].type == "C2" || resp.alarms[i].type == "C3" || resp.alarms[i].type == "C4") {
                  if (alarmRanges.beerPressureMax == 1) {
                    alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bar";
                  } else {
                    alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bares";
                  }
                }
                if (resp.alarms[i].type == "D1" || resp.alarms[i].type == "D2" || resp.alarms[i].type == "D3" || resp.alarms[i].type == "D4") {
                  if (alarmRanges.beerPressureMin == 1) {
                    alarmRange = "Presión mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bar";
                  } else {
                    alarmRange = "Presión mímina: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bares";
                  }
                }
                tankID = tankJson.id
              }
              let type = resp.alarms[i].desc2;
              let valorAlarma = this.deviceService.devolverValorAlarma(resp.alarms[i].type, lastReaderJson, tankJson);
              console.log("Hola", resp.alarms[i])
              this.alarmasActivadas.push({
                f_inicio: resp.alarms[i].started_at ?? "-",
                type: type ?? "-",
                type_symbol: resp.alarms[i].type,
                rango: alarmRange,
                tankID: tankID,
                valorAlarma: valorAlarma,
                deviceLabel: resp.alarms[i].device.dev_label,
                deviceRef: resp.alarms[i].device.dev_reference
              });
            }
          }
        }, error: err => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject();
        }, complete: async () => {
          // ALARMAS DESACTIVADAS
          if (this.alarmas.length == 0) {
            this.hayAlarmasDesactivadas = false;
          } else {
            this.hayAlarmasDesactivadas = true;
          }
          this.dataSourceAlarms = new MatTableDataSource(this.alarmas);
          // console.log("this.dataSourceAlarms", this.dataSourceAlarms)
          setTimeout(() => {
            this.dataSourceAlarms.sort = this.sort3;
            this.dataSourceAlarms.paginator = this.paginator1;
          }, 0);

          // ALARMAS ACTIVADAS
          if (this.alarmasActivadas.length == 0) {
            this.hayAlarmasActivadas = false;
          } else {
            this.hayAlarmasActivadas = true;
          }
          this.numeroAlarmasActivadas = this.alarmasActivadas.length;
          this.alarmasConOO = this.alarmasActivadas.filter((alarma: { type_symbol: string; }) => alarma.type_symbol === 'OO');
          
          this.alarmasConOO = this.alarmasConOO.map((alarma: { deviceRef: any; }) => {
            const dispositivo = this.establecimientoActual.devices.find(
              (d: { dev_reference: any; }) => d.dev_reference === alarma.deviceRef
            );
            const tanques = dispositivo?.tanks || [];
            return {
              ...alarma,
              tanques: tanques
            };
          });

          this.alarmasDesconexion = this.alarmasConOO
          .map((a: any) => {
            if (!a.deviceRef) return null;

            const customNums = a.tanques?.map((t: any) => t.custom_num).filter((n: any) => n !== undefined);

            const customNumsStr = customNums?.length
              ? ` (${customNums.map((n: number) => `T${n}`).join(', ')})`
              : '';

            const fechaInicio = a.f_inicio ? ` - desde ${a.f_inicio}` : '';

            return `${a.deviceRef}${customNumsStr}${fechaInicio}`;
          })
          .filter((label: string | null): label is string => !!label);
          console.log("this.establecimientoActual", this.establecimientoActual)
          console.log("this.establecimientoActual", this.alarmasDesconexion)
          this.dataSourceAlarmsActivas = new MatTableDataSource(this.alarmasActivadas);
          if (!this.actualizar) {
            setTimeout(() => {
              this.dataSourceAlarmsActivas.sort = this.sort2;
            }, 0);
          }
          resolve();
        }
      });
    })
  }

  devolverCerveza(cervezaID: number) {
    const cerveza = this.beersData.find((cerveza: any) => cerveza.id == cervezaID);
    return cerveza
  }

  devolverUltimaLecturaEstablecimiento() {
    const listaLecturas: any = [];
    for (let i = 0; i < this.establecimientoActual.devices.length; i++) {
      const device = this.establecimientoActual.devices[i];
      if (device.lastreader && device.lastreader.created_at) {
        listaLecturas.push(device.lastreader.created_at);
      }
    }
    const ultimaLectura = listaLecturas[listaLecturas.length - 1];
    return ultimaLectura || "--";
  }

  devolverUltimaLecturaEstablecimientoArray() {
    const listaLecturas: any = [];
    for (let i = 0; i < this.establecimientoActual.devices.length; i++) {
      const device = this.establecimientoActual.devices[i];
      const label = this.establecimientoActual.devices[i].dev_label
      if (device.lastreader && device.lastreader.created_at) {
        listaLecturas.push([label, device.lastreader.created_at]);
      }
    }
    return listaLecturas
  }

  devolverUltimaLecturaTemperaturaAmbiente() {
    let ultimaLectura: string | undefined;
    for (let i = 0; i < this.establecimientoActual.devices.length; i++) {
      const device = this.establecimientoActual.devices[i];
      if (device.lastreader && device.lastreader.created_at) {
        if (!ultimaLectura || device.lastreader.created_at > ultimaLectura) {
          ultimaLectura = device.lastreader.field9;
        }
      }
    }
    return ultimaLectura || "--";
  }

  devolverTanquePorSlotYLista(tanques: any, slotBuscado: number) {
    const tanqueEncontrado = tanques.find((tanque: any) => tanque.slot === slotBuscado);
    if (tanqueEncontrado) {
      return tanqueEncontrado;
    } else {
      return null;
    }
  }

  devolverDispositivo(dispositivoID: number) {
    const dispositivo = this.dispositivosEnEstablecimientoActual.find((dispositivo: any) => dispositivo.id == dispositivoID);
    return dispositivo;
  }

  devolverTanqueEnEstablecimiento(tanqueID: number) {
    const tanque = this.tanquesEnEstablecimientoActual.find((tanque: any) => tanque.id == tanqueID);
    return tanque;
  }

  devolvercondicionTanqueActivo(tanqueID: number) {
    const tanque = this.devolverTanqueEnEstablecimiento(tanqueID);
    if (tanque.dispositivo.lastreader.field2 == tanque.slot) {
      return true
    } else {
      return false;
    }
  }

  // CALCULAR CONSUMO DEL DÍA

  calcularConsumoDiaActual() {
    this.calcularDevicesReferences([this.establecimientoActual]);
    this.consumoDiaActual = [];
    return new Promise<void>((resolve, reject) => {
      const diaSiguiente = this.obtenerDiaSiguiente(this.fechaFormateada);
      this.historicoDiaSubscription = this.deviceService.getMultiHistoricRaw(this.devicesReferences, this.fechaFormateada, diaSiguiente, "0").subscribe({
        next: resp => {
          const camposTanque1 = ['field11', 'field12', 'field20'];
          const camposTanque2 = ['field13', 'field14', 'field21'];
          const camposTanque3 = ['field15', 'field16', 'field22'];
          const camposTanque4 = ['field26', 'field27', 'field28'];

          for (let i = 0; i < resp.length; i++) {
            const tanques = {
              tanque1: this.obtenerDatosTanque(resp[i], camposTanque1, 'beer_type_id_1'),
              tanque2: this.obtenerDatosTanque(resp[i], camposTanque2, 'beer_type_id_2'),
              tanque3: this.obtenerDatosTanque(resp[i], camposTanque3, 'beer_type_id_3'),
              tanque4: this.obtenerDatosTanque(resp[i], camposTanque4, 'beer_type_id_4'),
            };

            const consumoTotal = this.calcularConsumoTotal([tanques.tanque1.consumo, tanques.tanque2.consumo, tanques.tanque3.consumo, tanques.tanque4.consumo]);

            this.consumoDiaActual.push({
              dispositivoId: resp[i].id,
              establecimientoId: resp[i].dev_est_id,
              tanques: tanques,
              consumoTotal: consumoTotal,
            });
          }
        },
        error: err => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        },
        complete: () => {
          this.calcularConsumoEnTanques();
          resolve();
        },
      });
    });
  }

  calcularConsumoTotal(consumos: number[]): number {
    return parseFloat((consumos.reduce((total, consumo) => total + consumo, 0)).toFixed(2));
  }

  obtenerDatosTanque(respItem: any, camposTanque: string[], cervezaProp: string): { cervezaId: string | null; consumo: number } {
    return {
      cervezaId: respItem.readers_raw[0]?.[cervezaProp] || null,
      consumo: this.calcularConsumoTanque(respItem.readers_raw, camposTanque),
    };
  }

  calcularConsumoTanque(readersRaw: any[], campos: string[]): number {
    let consumoTanque = 0;
    readersRaw.forEach(reader => {
      campos.forEach(campo => {
        if (reader && reader[campo] !== undefined) {
          consumoTanque += parseFloat(reader[campo] !== null ? reader[campo] : 0);
        } else {
          consumoTanque += 0;
        }
      });
    });
    return parseFloat(consumoTanque.toFixed(2));
  }

  calcularConsumoEnTanques() {
    const listaAuxiliar: any = [];
    this.consumoDiaActual.forEach((consumo: any) => {
      const { dispositivoId, tanques } = consumo;

      listaAuxiliar.push({
        deviceId: dispositivoId,
        slot: 1,
        consumo: tanques.tanque1.consumo,
      });
      listaAuxiliar.push({
        deviceId: dispositivoId,
        slot: 2,
        consumo: tanques.tanque2.consumo,
      });
      listaAuxiliar.push({
        deviceId: dispositivoId,
        slot: 3,
        consumo: tanques.tanque3.consumo,
      });
      listaAuxiliar.push({
        deviceId: dispositivoId,
        slot: 4,
        consumo: tanques.tanque4.consumo,
      });
    });
    this.litrosConsumidosPorTanque = listaAuxiliar;
  }

  devolverConsumoEnTanque(deviceId: number, slot: number): number {
    const datoTanque = this.litrosConsumidosPorTanque.find(
      (dato: DatosTanque) => dato.deviceId === deviceId && dato.slot === slot
    );
    return datoTanque ? datoTanque.consumo : 0;
  }

  obtenerDiaSiguiente(diaActual: string): string {
    const fechaObjeto = new Date(diaActual);
    const diaSiguiente = addDays(fechaObjeto, 1);
    return diaSiguiente.toISOString().slice(0, 10);
  }

  calcularDevicesReferences(establecimientos: any) {
    let devicesReferencesLista: any = [];
    for (let i = 0; i < establecimientos.length; i++) {
      const references: string[] = establecimientos[i].devices.map((device: { dev_reference: string }) => device.dev_reference);
      devicesReferencesLista = devicesReferencesLista.concat(references);
    }
    this.devicesReferences = devicesReferencesLista.join('-');
  }

  calcularDevicesIds(establecimientos: any) {
    let devicesIdsLista: number[] = [];
    for (let i = 0; i < establecimientos.length; i++) {
      for (let j = 0; j < establecimientos[i].devices.length; j++) {
        devicesIdsLista.push(establecimientos[i].devices[j].id)
      }
    }
    return devicesIdsLista;
    /*const devicesIdsJSON: string = JSON.stringify(devicesIdsLista);
    console.log(devicesIdsJSON);*/
  }

  // GAUGES

  cargarGuage(tanqueID: number) {
    const tanque = this.devolverTanqueEnEstablecimiento(tanqueID);
    const dispositivo = this.devolverDispositivo(tanque.dispositivo.id);

    const nivelTanque = this.devolverNivelActualDelTanque(tanque.id, tanque.slot, dispositivo, tanque.capacity);
    const temperaturaTanque = this.devolverTemperaturaActualDelTanque(tanque.id, tanque.slot, dispositivo);
    const presionTanque = this.devolverPresionActualDelTanque(tanque.id, tanque.slot, dispositivo);

    const alarmRanges = JSON.parse(tanque.alarm_ranges);
    const alarmaNivel = alarmRanges.beerLevelMin ?? 0;
    let alarmaTemeraturaMin = alarmRanges.beerTemperatureMin;
    let alarmaTemeraturaMax = alarmRanges.beerTemperatureMax;
    let alarmaPresionMin = alarmRanges.beerPressureMin;
    let alarmaPresionMax = alarmRanges.beerPressureMax;

    const ticksformateadosTemperatura = this.calcularMajorTicks(alarmaTemeraturaMin, alarmaTemeraturaMax, 1, 10, temperaturaTanque);
    let highlightsTermperatura: Array<{
      from: number;
      to: number;
      color: string;
    }> = [];

    const ticksformateadosPresion = this.calcularMajorTicks(alarmaPresionMin, alarmaPresionMax, 1, 6, presionTanque);
    let highlightsPresion: Array<{
      from: number;
      to: number;
      color: string;
    }> = [];

    setTimeout(() => {
      // NIVEL
      /*const gaugeNivel = new RadialGauge({
        renderTo: 'nivelTanque' + tanque.id,
        width: 190,
        height: 200,

        // Value
        minValue: 0,
        maxValue: 100,

        // Ticks
        majorTicks: [0,10,20,30,40,50,60,70,80,90,100],
        minorTicks: 2,
        strokeTicks: true,

        // Value box
        valueBox: false,
        colorValueBoxBackground: "transparent",
        colorValueBoxShadow: "falsy",
        valueBoxStroke: 0,

        // Angle
        startAngle: 0,
        ticksAngle: 360,

        // Borders 
        borders: false,
        borderShadowWidth: 0,

        // Bar
        barProgress: true,
        barWidth: 8,
        barStrokeWidth: 0.7,
        barShadow: 20,
        colorBarProgress: "#FFA53D",
        //colorBar: "#eaa",

        // Animation
        animation: true,
        animationTarget: "needle",
        animationRule: "quint",
        animationDuration: 1500,

        // Highlights
        highlightsWidth: 12,
        highlights: [
          {
            "from": alarmaNivel,
            "to": 100,
            "color": "rgb(0, 224, 0)"
          },
          {
            "from": 0,
            "to": alarmaNivel,
            "color": "#B00B1F"
          }
        ]
      }).draw();
      gaugeNivel.value = nivelTanque;*/

      // const gaugeNivel = new LinearGauge({
      //   renderTo: 'nivelTanque' + tanque.id,
      //   width: 105,
      //   height: 190,
      //   units: "%",
      //   colorPlate: "transparent",

      //   // Value
      //   minValue: 0,
      //   maxValue: 100,

      //   // Ticks
      //   majorTicks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      //   minorTicks: 2,
      //   strokeTicks: true,
      //   ticksWidth: 13,
      //   ticksWidthMinor: 6,
      //   majorTicksDec: 0,

      //   // Side
      //   tickSide: "left",
      //   needleSide: "right",
      //   numberSide: "left",

      //   // Value box
      //   valueBox: false,
      //   colorValueBoxBackground: "transparent",
      //   colorValueBoxShadow: "falsy",
      //   valueBoxStroke: 0,

      //   // Borders 
      //   borders: false,
      //   borderShadowWidth: 0,

      //   // Bar
      //   barProgress: true,
      //   barWidth: 11,
      //   barStrokeWidth: 0.7,
      //   barShadow: 20,
      //   colorBarProgress: "#FFA53D",
      //   barBeginCircle: 0,
      //   //colorBar: "#eaa",

      //   // Animation
      //   animation: true,
      //   animationRule: "quint",
      //   animationDuration: 1500,

      //   // Highlights
      //   highlightsWidth: 10,
      //   highlights: [
      //     {
      //       "from": alarmaNivel,
      //       "to": 100,
      //       "color": "#FBB040"
      //     },
      //     {
      //       "from": 0,
      //       "to": alarmaNivel,
      //       "color": "#868686"
      //     }
      //   ]
      // }).draw();
      // if (nivelTanque < 0) {
      //   gaugeNivel.value = 0;
      // } else {
      //   if (nivelTanque > 100) {
      //     gaugeNivel.value = 100;
      //   } else {
      //     gaugeNivel.value = nivelTanque;
      //   }
      // }

      const targetN = document.querySelector('#fluidNivelTanque' + tanque.id) as HTMLElement;
      let fluidMeterN: any = null;
      if (targetN !== null) {
        let color = "black";
        let borderColor = "white";
        if (tanque.recargaNecesaria) {
          color = "#ff0000";
          borderColor = "#ff0000";
        }
        fluidMeterN = new CircularFluidMeter(targetN, {
          initialProgress: 0,
          borderWidth: 5,
          maxProgress: 100,
          backgroundColor: 'black',
          borderColor: borderColor,
          dropShadowColor: color,
          bubbleColor: 'white',
          showBubbles: false,
          fontFamily: 'Montserrat',
          fontSize: 30,
          progressFormatter: (value) => {
            return `${value.toFixed(2)}%`;
          },
          fluidConfiguration: {
            color: '#F28E1C',
            horizontalSpeed: Speed.SLOW,
            waveSpeed: Speed.SLOW
          }
        });
        fluidMeterN.progress = nivelTanque
      }

      // TEMPERATURA
      const gaugeTemperatura = new LinearGauge({
        renderTo: 'temperaturaTanque' + tanque.id,
        //title: "Temperatura",
        width: 165,
        height: 190,
        colorPlate: "transparent",

        // Value
        valueInt: 1,
        valueDec: 1,
        minValue: ticksformateadosTemperatura[0],
        maxValue: ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],

        // Ticks
        tickSide: "right",
        needleSide: "right",
        numberSide: "right",
        majorTicks: ticksformateadosTemperatura,
        minorTicks: 2,
        ticksWidth: 13,
        ticksWidthMinor: 6,
        ticksPadding: 6,
        fontNumbersSize: 14,
        majorTicksDec: 0,

        // Value Box
        valueBox: false,
        colorValueBoxBackground: "transparent",
        colorValueBoxShadow: "falsy",
        valueBoxStroke: 0,
        valueText: temperaturaTanque + " °C",

        // Border
        borderRadius: 5,
        borders: false,
        borderShadowWidth: 0,

        // Circle
        barBeginCircle: 17,

        // Bar
        barWidth: 7,
        //colorBar: "#e3143a",
        colorBarEnd: "#FBB040",
        //colorBarProgress: "#3292D2",
        colorBarProgressEnd: "#FBB040",

        // Animation
        animationDuration: 1500,

        // Needle
        needle: true,
        needleWidth: 6,
        needleEnd: 110,
        needleStart: 20,

        // Highlights
        highlightsWidth: 7,

      })

      if (alarmaTemeraturaMax !== null && alarmaTemeraturaMin !== null) {
        highlightsTermperatura = [
          {
            "from": ticksformateadosTemperatura[0],
            "to": alarmaTemeraturaMin,
            "color": "#868686"
          },
          {
            "from": alarmaTemeraturaMin,
            "to": alarmaTemeraturaMax,
            "color": "#FBB040"
          },
          {
            "from": alarmaTemeraturaMax,
            "to": ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],
            "color": "#868686"
          }
        ]
      } else {
        if (alarmaTemeraturaMax == null && alarmaTemeraturaMin == null) {
          highlightsTermperatura = [
            {
              "from": ticksformateadosTemperatura[0],
              "to": ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],
              "color": "#FBB040"
            },
          ]
        } else {
          if (alarmaTemeraturaMax !== null && alarmaTemeraturaMin == null) {
            highlightsTermperatura = [
              {
                "from": ticksformateadosTemperatura[0],
                "to": alarmaTemeraturaMax,
                "color": "#FBB040"
              },
              {
                "from": alarmaTemeraturaMax,
                "to": ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],
                "color": "#868686"
              }
            ]
          }
          if (alarmaTemeraturaMax == null && alarmaTemeraturaMin !== null) {
            highlightsTermperatura = [
              {
                "from": ticksformateadosTemperatura[0],
                "to": alarmaTemeraturaMin,
                "color": "#868686"
              },
              {
                "from": alarmaTemeraturaMin,
                "to": ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],
                "color": "#FBB040"
              },
            ]
          }
        }
      }
      gaugeTemperatura.options.highlights = highlightsTermperatura;
      gaugeTemperatura.value = temperaturaTanque;
      gaugeTemperatura.draw();

      // PRESION
      const gaugePresion = new RadialGauge({
        renderTo: 'presionTanque' + tanque.id,
        width: 175,
        height: 190,

        minValue: ticksformateadosPresion[0],
        maxValue: ticksformateadosPresion[ticksformateadosPresion.length - 1],

        // Units
        //colorUnits: "#ccc",
        //colorNumbers: "#eee",

        // Ticks
        majorTicks: ticksformateadosPresion,
        minorTicks: 3,
        //colorMajorTicks: "#f5f5f5",
        //colorMinorTicks: "#ddd",
        strokeTicks: true,
        majorTicksDec: 1,

        // Value Box
        valueBox: false,

        // Border
        borders: true,
        borderShadowWidth: 5,
        borderOuterWidth: 0,
        borderMiddleWidth: 0,
        borderInnerWidth: 0,
        //colorPlate: "#444",

        // Needle
        needleType: "arrow",
        needleWidth: 4,
        needleShadow: false,
        /*colorNeedle: "#BE351A",
        colorNeedleEnd: "#BE351A",
        colorNeedleCircleOuter: "#333",
        colorNeedleCircleOuterEnd: "#111",
        colorNeedleCircleInner: "#111",
        colorNeedleCircleInnerEnd: "#222",*/

        // Animation
        animationDuration: 1500,

        // Highlights
        highlightsWidth: 12,
      })

      if (alarmaPresionMax !== null && alarmaPresionMin !== null) {
        highlightsPresion = [
          {
            "from": ticksformateadosPresion[0],
            "to": alarmaPresionMin,
            "color": "#868686"
          },
          {
            "from": alarmaPresionMin,
            "to": alarmaPresionMax,
            "color": "#FBB040"
          },
          {
            "from": alarmaPresionMax,
            "to": ticksformateadosPresion[ticksformateadosPresion.length - 1],
            "color": "#868686"
          }
        ]
      } else {
        if (alarmaPresionMax == null && alarmaPresionMin == null) {
          highlightsPresion = [
            {
              "from": ticksformateadosPresion[0],
              "to": ticksformateadosPresion[ticksformateadosPresion.length - 1],
              "color": "#FBB040"
            },
          ]
        } else {
          if (alarmaPresionMax !== null && alarmaPresionMin == null) {
            highlightsPresion = [
              {
                "from": ticksformateadosPresion[0],
                "to": alarmaPresionMax,
                "color": "#FBB040"
              },
              {
                "from": alarmaPresionMax,
                "to": ticksformateadosPresion[ticksformateadosPresion.length - 1],
                "color": "#868686"
              }
            ]
          }
          if (alarmaPresionMax == null && alarmaPresionMin !== null) {
            highlightsPresion = [
              {
                "from": ticksformateadosPresion[0],
                "to": alarmaPresionMin,
                "color": "#868686"
              },
              {
                "from": alarmaPresionMin,
                "to": ticksformateadosPresion[ticksformateadosPresion.length - 1],
                "color": "#FBB040"
              },
            ]
          }
        }
      }
      gaugePresion.options.highlights = highlightsPresion;
      gaugePresion.value = presionTanque;
      gaugePresion.draw();

      this.gaugesLista.push({
        tanque: tanque,
        fluidNivel: fluidMeterN,
        // gaugeNivel: gaugeNivel,
        gaugePresion: gaugePresion,
        gaugeTemperatura: gaugeTemperatura
      });
    }, 0)
  }

  destroyGauges() {
    //console.log(this.gaugesLista);
    for (let i = 0; i < this.gaugesLista.length; i++) {
      try {
        this.gaugesLista[i].fluidNivel.dispose();
      } catch (e) {
        location.reload();
      }
      // this.gaugesLista[i].gaugeNivel.destroy();
      this.gaugesLista[i].gaugePresion.destroy();
      this.gaugesLista[i].gaugeTemperatura.destroy();
    }
  }

  actualizarGauges(tanqueID: number) {
    //const tanque = this.devolverTanqueEnEstablecimiento(tanqueID);
    const tanqueConHistorico = this.historicosEnTanques.find((tanque: any) => tanque.id == tanqueID);
    //const dispositivo = this.devolverDispositivo(tanque.dispositivo.id);
    const gaugueInfo = this.gaugesLista.find((gauges: any) => gauges.tanque.id == tanqueID);

    //const nivelTanque = this.devolverNivelActualDelTanque(tanque.slot, dispositivo, tanque.capacity);
    //const temperaturaTanque = this.devolverTemperaturaActualDelTanque(tanque.slot, dispositivo);
    //const presionTanque = this.devolverPresionActualDelTanque(tanque.slot, dispositivo);

    const ultimoHistorico = tanqueConHistorico.historicoFechas.length - 1;
    const ultimoHistoricoNivel = tanqueConHistorico.historicosNivel[ultimoHistorico];

    const nivelActual = ultimoHistoricoNivel !== null ? ((parseFloat(ultimoHistoricoNivel) * 100) / tanqueConHistorico.capacity).toFixed(1) : "--";
    const temperaturaTanque = tanqueConHistorico.historicosTemperatura[ultimoHistorico];
    const presionTanque = tanqueConHistorico.historicosPresion[ultimoHistorico];

    let highlightsNivel: Array<{
      from: number;
      to: number;
      color: string;
    }> = [];
    let highlightsTermperatura: Array<{
      from: number;
      to: number;
      color: string;
    }> = [];
    let highlightsPresion: Array<{
      from: number;
      to: number;
      color: string;
    }> = [];

    const tanqueConAlarmas = this.tanquesEnEstablecimientoActual.find((tanque: any) => tanque.id == tanqueID);
    const alarmRanges = JSON.parse(tanqueConAlarmas.alarm_ranges);
    const alarmaNivel = alarmRanges.beerLevelMin ?? 0;
    let alarmaTemeraturaMin = alarmRanges.beerTemperatureMin;
    let alarmaTemeraturaMax = alarmRanges.beerTemperatureMax;
    let alarmaPresionMin = alarmRanges.beerPressureMin;
    let alarmaPresionMax = alarmRanges.beerPressureMax;

    const ticksformateadosTemperatura = this.calcularMajorTicks(alarmaTemeraturaMin, alarmaTemeraturaMax, 1, 10, temperaturaTanque);
    const ticksformateadosPresion = this.calcularMajorTicks(alarmaPresionMin, alarmaPresionMax, 1, 6, presionTanque);

    // GAUGE NIVEL
    // highlightsNivel = [
    //   {
    //     "from": alarmaNivel,
    //     "to": 100,
    //     "color": "#FBB040"
    //   },
    //   {
    //     "from": 0,
    //     "to": alarmaNivel,
    //     "color": "#868686"
    //   }
    // ];
    // gaugueInfo.gaugeNivel.options.highlights = highlightsNivel;
    // if (parseInt(nivelActual) < 0) {
    //   gaugueInfo.gaugeNivel.value = 0;
    // } else {
    //   if (parseInt(nivelActual) > 100) {
    //     gaugueInfo.gaugeNivel.value = 100;
    //   } else {
    //     gaugueInfo.gaugeNivel.value = nivelActual;
    //   }
    // }
    // gaugueInfo.gaugeNivel.update();
    // gaugueInfo.fluidNivel = nivelActual;

    // GAUGE TEMPERATURA 
    if (alarmaTemeraturaMax !== null && alarmaTemeraturaMin !== null) {
      highlightsTermperatura = [
        {
          "from": ticksformateadosTemperatura[0],
          "to": alarmaTemeraturaMin,
          "color": "#868686"
        },
        {
          "from": alarmaTemeraturaMin,
          "to": alarmaTemeraturaMax,
          "color": "#FBB040"
        },
        {
          "from": alarmaTemeraturaMax,
          "to": ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],
          "color": "#868686"
        }
      ]
    } else {
      if (alarmaTemeraturaMax == null && alarmaTemeraturaMin == null) {
        highlightsTermperatura = [
          {
            "from": ticksformateadosTemperatura[0],
            "to": ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],
            "color": "#FBB040"
          },
        ]
      } else {
        if (alarmaTemeraturaMax !== null && alarmaTemeraturaMin == null) {
          highlightsTermperatura = [
            {
              "from": ticksformateadosTemperatura[0],
              "to": alarmaTemeraturaMax,
              "color": "#FBB040"
            },
            {
              "from": alarmaTemeraturaMax,
              "to": ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],
              "color": "#868686"
            }
          ]
        }
        if (alarmaTemeraturaMax == null && alarmaTemeraturaMin !== null) {
          highlightsTermperatura = [
            {
              "from": ticksformateadosTemperatura[0],
              "to": alarmaTemeraturaMin,
              "color": "#868686"
            },
            {
              "from": alarmaTemeraturaMin,
              "to": ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1],
              "color": "#FBB040"
            },
          ]
        }
      }
    }
    gaugueInfo.gaugeTemperatura.options.highlights = highlightsTermperatura;
    gaugueInfo.gaugeTemperatura.options.minValue = ticksformateadosTemperatura[0];
    gaugueInfo.gaugeTemperatura.options.maxValue = ticksformateadosTemperatura[ticksformateadosTemperatura.length - 1];
    gaugueInfo.gaugeTemperatura.options.majorTicks = ticksformateadosTemperatura;
    gaugueInfo.gaugeTemperatura.value = temperaturaTanque;
    gaugueInfo.gaugeTemperatura.update();

    // GAUGE PRESION
    if (alarmaPresionMax !== null && alarmaPresionMin !== null) {
      highlightsPresion = [
        {
          "from": ticksformateadosPresion[0],
          "to": alarmaPresionMin,
          "color": "#868686"
        },
        {
          "from": alarmaPresionMin,
          "to": alarmaPresionMax,
          "color": "#FBB040"
        },
        {
          "from": alarmaPresionMax,
          "to": ticksformateadosPresion[ticksformateadosPresion.length - 1],
          "color": "#868686"
        }
      ]
    } else {
      if (alarmaPresionMax == null && alarmaPresionMin == null) {
        highlightsPresion = [
          {
            "from": ticksformateadosPresion[0],
            "to": ticksformateadosPresion[ticksformateadosPresion.length - 1],
            "color": "#FBB040"
          },
        ]
      } else {
        if (alarmaPresionMax !== null && alarmaPresionMin == null) {
          highlightsPresion = [
            {
              "from": ticksformateadosPresion[0],
              "to": alarmaPresionMax,
              "color": "#FBB040"
            },
            {
              "from": alarmaPresionMax,
              "to": ticksformateadosPresion[ticksformateadosPresion.length - 1],
              "color": "#868686"
            }
          ]
        }
        if (alarmaPresionMax == null && alarmaPresionMin !== null) {
          highlightsPresion = [
            {
              "from": ticksformateadosPresion[0],
              "to": alarmaPresionMin,
              "color": "#868686"
            },
            {
              "from": alarmaPresionMin,
              "to": ticksformateadosPresion[ticksformateadosPresion.length - 1],
              "color": "#FBB040"
            },
          ]
        }
      }
    }
    gaugueInfo.gaugePresion.options.highlights = highlightsPresion;
    gaugueInfo.gaugePresion.options.minValue = ticksformateadosPresion[0];
    gaugueInfo.gaugePresion.options.maxValue = ticksformateadosPresion[ticksformateadosPresion.length - 1];
    gaugueInfo.gaugePresion.options.majorTicks = ticksformateadosPresion;
    gaugueInfo.gaugePresion.value = presionTanque;
    gaugueInfo.gaugePresion.update();
  }

  devolverNivelActualDelTanque(tanqueID: number, slot: number, device: any, capacity: number): any {
    // Si la fecha actual está incluida cogemos los datos del historico y sino de la ultima lectura del device
    if (!this.recargarGrafica || this.llamarOptimizada || this.historicosEnTanques.length == 0) {
      switch (slot) {
        case 1:
          return device.lastreader.field17 !== null ? ((parseFloat(device.lastreader.field17) * 100) / capacity).toFixed(2) : "--";
        case 2:
          return device.lastreader.field18 !== null ? ((parseFloat(device.lastreader.field18) * 100) / capacity).toFixed(2) : "--";
        case 3:
          return device.lastreader.field19 !== null ? ((parseFloat(device.lastreader.field19) * 100) / capacity).toFixed(2) : "--";
        case 4:
          return device.lastreader.field25 !== null ? ((parseFloat(device.lastreader.field25) * 100) / capacity).toFixed(2) : "--";
        default:
          return "--";
      }
    } else {
      if (this.recargarGrafica && !this.llamarOptimizada && this.historicosEnTanques.length > 0) {
        const tanqueConHistorico = this.historicosEnTanques.find((tanque: any) => tanque.id == tanqueID);
        const ultimoHistorico = tanqueConHistorico.historicoFechas.length - 1;
        const ultimoHistoricoNivel = tanqueConHistorico.historicosNivel[ultimoHistorico];
        const nivelActual = ultimoHistoricoNivel !== null ? ((parseFloat(ultimoHistoricoNivel) * 100) / tanqueConHistorico.capacity).toFixed(2) : "--";
        return parseFloat(nivelActual).toFixed(2);
      }
    }
  }

  devolverNivel(tanqueID: number, slot: number, device: any): any {
    // Si la fecha actual está incluida cogemos los datos del historico y sino de la ultima lectura del device
    if (!this.recargarGrafica || this.llamarOptimizada || this.historicosEnTanques.length == 0) {
      switch (slot) {
        case 1:
          return device.lastreader.field17 !== null ? parseFloat(device.lastreader.field17).toFixed(2) : "--";
        case 2:
          return device.lastreader.field18 !== null ? parseFloat(device.lastreader.field18).toFixed(2) : "--";
        case 3:
          return device.lastreader.field19 !== null ? parseFloat(device.lastreader.field19).toFixed(2) : "--";
        case 4:
          return device.lastreader.field25 !== null ? parseFloat(device.lastreader.field25).toFixed(2) : "--";
        default:
          return "--";
      }
    } else {
      if (this.recargarGrafica && !this.llamarOptimizada && this.historicosEnTanques.length > 0) {
        const tanqueConHistorico = this.historicosEnTanques.find((tanque: any) => tanque.id == tanqueID);
        const ultimoHistorico = tanqueConHistorico.historicoFechas.length - 1;
        const ultimoHistoricoNivel = tanqueConHistorico.historicosNivel[ultimoHistorico];
        const nivelActual = ultimoHistoricoNivel !== null ? (parseFloat(ultimoHistoricoNivel)).toFixed(2) : "--";
        return parseFloat(nivelActual).toFixed(2);
      }
    }
  }

  devolverTemperaturaActualDelTanque(tanqueID: number, slot: number, device: any): any {
    if (!this.recargarGrafica || this.llamarOptimizada || this.historicosEnTanques.length == 0) {
      switch (slot) {
        case 1:
          return device.lastreader.field6 !== null ? parseFloat(device.lastreader.field6).toFixed(2) : "--";
        case 2:
          return device.lastreader.field7 !== null ? parseFloat(device.lastreader.field7).toFixed(2) : "--";
        case 3:
          return device.lastreader.field8 !== null ? parseFloat(device.lastreader.field8).toFixed(2) : "--";
        case 4:
          return device.lastreader.field24 !== null ? parseFloat(device.lastreader.field24).toFixed(2) : "--";
        default:
          return "--";
      }
    } else {
      if (this.recargarGrafica && !this.llamarOptimizada && this.historicosEnTanques.length > 0) {
        const tanqueConHistorico = this.historicosEnTanques.find((tanque: any) => tanque.id == tanqueID);
        const ultimoHistorico = tanqueConHistorico.historicoFechas.length - 1;
        return parseFloat(tanqueConHistorico.historicosTemperatura[ultimoHistorico]).toFixed(2);
      }
    }
  }

  devolverPresionActualDelTanque(tanqueID: number, slot: number, device: any): any {
    if (!this.recargarGrafica || this.llamarOptimizada || this.historicosEnTanques.length == 0) {
      switch (slot) {
        case 1:
          return device.lastreader.field3 !== null ? parseFloat(device.lastreader.field3).toFixed(2) : "--";
        case 2:
          return device.lastreader.field4 !== null ? parseFloat(device.lastreader.field4).toFixed(2) : "--";
        case 3:
          return device.lastreader.field5 !== null ? parseFloat(device.lastreader.field5).toFixed(2) : "--";
        case 4:
          return device.lastreader.field23 !== null ? parseFloat(device.lastreader.field23).toFixed(2) : "--";
        default:
          return "--";
      }
    } else {
      if (this.recargarGrafica && !this.llamarOptimizada && this.historicosEnTanques.length > 0) {
        const tanqueConHistorico = this.historicosEnTanques.find((tanque: any) => tanque.id == tanqueID);
        const ultimoHistorico = tanqueConHistorico.historicoFechas.length - 1;
        return parseFloat(tanqueConHistorico.historicosPresion[ultimoHistorico]).toFixed(2);
      }
    }
  }

  // ESTABLECIMIENTO COMPLETO //

  convertirFechas(listaFechas: string[]): string[] {
    const fechasFormateadas = listaFechas.map((fechaString: string) => {
      const fecha = new Date(fechaString);
      const dia = fecha.getDate();
      const mes = fecha.getMonth() + 1;
      const año = fecha.getFullYear();
      return `${dia < 10 ? '0' : ''}${dia}-${mes < 10 ? '0' : ''}${mes}-${año} ${fecha.getHours()}:${fecha.getMinutes()}:${fecha.getSeconds()}`;
    });
    return fechasFormateadas;
  }

  actualizarTodayCharts(start: string, end: string) {
    let historialObservable;
    if (this.llamarOptimizada) {
      historialObservable = this.deviceService.getMultiHistoricNoScale(this.devicesReferences, start, end);
    } else {
      historialObservable = this.deviceService.getMultiHistoricRaw(this.devicesReferences, start, end, this.selectedValue);
    }
    const nombreCampoLecturas = this.llamarOptimizada ? 'readers' : 'readers_raw';
    this.historialSubscription = historialObservable.subscribe({
      next: (resp) => {
        const dispositivoConLecturas = [];
        //console.log(this.deviceHistoryMap[deviceReference]);
        /*Si la nueva respuesta es más grande que la primera respuesta de historicos significa que se ha recibido un nuevo historico*/
        for (let i = 0; i < resp.length; i++) {
          const readers = resp[i][nombreCampoLecturas];
          // Actualizar información de la lista de dispostivos
          let dispositivo = this.devolverDispositivo(resp[i].id);
          dispositivoConLecturas.push({
            ...dispositivo,
            readers_raw: readers
          });
          this.historicosEnDispositivo = dispositivoConLecturas;
          this.obtenerTemperaturaAmbienteYLecturaMasAntiguaDeLaLecturaMasAntigua(this.historicosEnDispositivo);
          //Filtrar los tanques del device de la respuesta
          const tanquesDelDispositivoActualConHistorico = this.historicosEnTanques.filter((tanque: any) => tanque.device_id == resp[i].id);
          if (tanquesDelDispositivoActualConHistorico.length > 0) {
            if (tanquesDelDispositivoActualConHistorico[0].historicoFechas.length < readers.length) {
              console.log("Nuevo histórico recibido");
              const ultimo = readers.length - 1;
              const nuevaFecha: string = readers[ultimo].created_at;
              for (let j = 0; j < tanquesDelDispositivoActualConHistorico.length; j++) {
                // Actualizar los valores de cada tanque
                tanquesDelDispositivoActualConHistorico[j].historicoFechas = this.devolverListaDeHistoricosFechas(readers, start, end);
                tanquesDelDispositivoActualConHistorico[j].historicosTemperatura = this.devolverListaDeHistoricosTemperatura(readers, tanquesDelDispositivoActualConHistorico[j]);
                tanquesDelDispositivoActualConHistorico[j].historicosTemperaturaAmbiente = this.devolverListaDeHistoricosTemperaturaAmbiente(readers),
                  tanquesDelDispositivoActualConHistorico[j].historicosPresion = this.devolverListaDeHistoricosPresion(readers, tanquesDelDispositivoActualConHistorico[j]);
                tanquesDelDispositivoActualConHistorico[j].historicosNivel = this.devolverListaDeHistoricosNivel(readers, tanquesDelDispositivoActualConHistorico[j]);
                tanquesDelDispositivoActualConHistorico[j].historicosConsumo = this.devolverListaDeHistoricosConsumo(readers, tanquesDelDispositivoActualConHistorico[j]);
                // Recorremos los charts y añadimos la nueva información de cada tanque
                this.charts.forEach((chart: any) => {
                  // GRAFICO DE TEMPERATURA
                  if (chart.canvas.id == "Temperatura") {
                    for (let z = 0; z < chart.data.datasets.length; z++) {
                      const currentLabel = chart.data.datasets[z].label;
                      // Añadir la temperatura del tanque
                      if (currentLabel.startsWith(' Tª tanque')) {
                        const match = currentLabel.match(/\s*Tª tanque (\d+)/);
                        if (match) {
                          const numeroTanque = parseInt(match[1], 10);
                          if (numeroTanque == tanquesDelDispositivoActualConHistorico[j].custom_num) {
                            const pointDataTemperatura = [];
                            const date = new Date(nuevaFecha);
                            pointDataTemperatura.push({
                              x: date,
                              y: tanquesDelDispositivoActualConHistorico[j].historicosTemperatura[tanquesDelDispositivoActualConHistorico[j].historicosTemperatura.length - 1]
                            });
                            chart.data.datasets[z].data.push(pointDataTemperatura[0]);
                          }
                        }
                      }
                      if (currentLabel.startsWith(' Tª ambiente')) {
                        const ultimaLecturaTemperaturaAmbiente = readers[ultimo].field9;
                        const pointDataTemperatura = [];
                        const date = new Date(nuevaFecha);
                        pointDataTemperatura.push({
                          x: date,
                          y: ultimaLecturaTemperaturaAmbiente
                        });
                        chart.data.datasets[z].data.push(pointDataTemperatura[0]);
                      }
                    }
                  }
                  if (chart.canvas.id == "Presion") {
                    for (let z = 0; z < chart.data.datasets.length; z++) {
                      const currentLabel = chart.data.datasets[z].label;
                      // Añadir la temperatura del tanque
                      if (currentLabel.startsWith(' P tanque')) {
                        const match = currentLabel.match(/\s*P tanque (\d+)/);
                        if (match) {
                          const numeroTanque = parseInt(match[1], 10);
                          if (numeroTanque == tanquesDelDispositivoActualConHistorico[j].custom_num) {
                            const pointDataTemperatura = [];
                            const date = new Date(nuevaFecha);
                            pointDataTemperatura.push({
                              x: date,
                              y: tanquesDelDispositivoActualConHistorico[j].historicosPresion[tanquesDelDispositivoActualConHistorico[j].historicosPresion.length - 1]
                            });
                            chart.data.datasets[z].data.push(pointDataTemperatura[0]);
                          }
                        }
                      }
                    }
                  }
                  if (chart.canvas.id == "Nivel-Consumo") {
                    for (let z = 0; z < chart.data.datasets.length; z++) {
                      const currentLabel = chart.data.datasets[z].label;
                      // Añadir la temperatura del tanque
                      if (currentLabel.startsWith(' Nivel tanque')) {
                        const match = currentLabel.match(/\s*Nivel tanque (\d+)/);
                        if (match) {
                          const numeroTanque = parseInt(match[1], 10);
                          if (numeroTanque == tanquesDelDispositivoActualConHistorico[j].custom_num) {
                            const pointDataTemperatura = [];
                            const date = new Date(nuevaFecha);
                            pointDataTemperatura.push({
                              x: date,
                              y: tanquesDelDispositivoActualConHistorico[j].historicosNivel[tanquesDelDispositivoActualConHistorico[j].historicosNivel.length - 1]
                            });
                            chart.data.datasets[z].data.push(pointDataTemperatura[0]);
                          }
                        }
                      }
                      if (currentLabel.startsWith(' Consumo tanque')) {
                        const match = currentLabel.match(/\s*Consumo tanque (\d+)/);
                        if (match) {
                          const numeroTanque = parseInt(match[1], 10);
                          if (numeroTanque == tanquesDelDispositivoActualConHistorico[j].custom_num) {
                            const pointDataTemperatura = [];
                            const date = new Date(nuevaFecha);
                            pointDataTemperatura.push({
                              x: date,
                              y: tanquesDelDispositivoActualConHistorico[j].historicosConsumo[tanquesDelDispositivoActualConHistorico[j].historicosConsumo.length - 1]
                            });
                            chart.data.datasets[z].data.push(pointDataTemperatura[0]);
                          }
                        }
                      }
                    }
                  }
                  chart.update();
                });
                // ESTADISTICAS DE TEMPERATUA
                const historicoTemperatura = tanquesDelDispositivoActualConHistorico[j].historicosTemperatura;
                if (this.hayAlgunValor(historicoTemperatura)) {
                  let nombreTanqueTemperatura = 'Tanque ' + tanquesDelDispositivoActualConHistorico[j].custom_num;
                  const maximoTemperatura = Math.max(...historicoTemperatura);
                  const minimoTemperatura = Math.min(...historicoTemperatura);
                  const mediaTemperatura = historicoTemperatura.reduce((acc: any, val: any) => acc + val, 0) / historicoTemperatura.length;

                  const tanqueEncontradoTemperatura = this.datosEstadisticosTemperatura.find((tanque: any) => tanque.nombre === nombreTanqueTemperatura);
                  if (tanqueEncontradoTemperatura) {
                    // Si se encuentra el tanque, actualiza sus valores
                    tanqueEncontradoTemperatura.historico = historicoTemperatura;
                    tanqueEncontradoTemperatura.maxima = this.soloDosDecimalesConComa(maximoTemperatura);
                    tanqueEncontradoTemperatura.minima = this.soloDosDecimalesConComa(minimoTemperatura);
                    tanqueEncontradoTemperatura.media = this.soloDosDecimalesConComa(mediaTemperatura);
                  } else {
                    // Si no se encuentra, añádelo a la lista
                    this.datosEstadisticosTemperatura.push({
                      nombre: nombreTanqueTemperatura,
                      historico: historicoTemperatura,
                      maxima: this.soloDosDecimalesConComa(maximoTemperatura),
                      minima: this.soloDosDecimalesConComa(minimoTemperatura),
                      media: this.soloDosDecimalesConComa(mediaTemperatura),
                    });
                  }
                }

                // ESTADÍSTICAS DE PRESION
                const historicoPresion = tanquesDelDispositivoActualConHistorico[j].historicosPresion;
                if (this.hayAlgunValor(historicoPresion)) {
                  let nombreTanquePresion = 'Tanque ' + tanquesDelDispositivoActualConHistorico[j].custom_num;
                  const maximoPresion = Math.max(...historicoPresion);
                  const minimoPresion = Math.min(...historicoPresion);
                  const mediaPresion = historicoPresion.reduce((acc: any, val: any) => acc + val, 0) / historicoPresion.length;

                  const tanqueEncontradoPresion = this.datosEstadisticosPresion.find((tanque: any) => tanque.nombre === nombreTanquePresion);
                  if (tanqueEncontradoPresion) {
                    // Si se encuentra el tanque, actualiza sus valores
                    tanqueEncontradoPresion.historico = historicoPresion;
                    tanqueEncontradoPresion.maxima = this.soloDosDecimalesConComa(maximoPresion);
                    tanqueEncontradoPresion.minima = this.soloDosDecimalesConComa(minimoPresion);
                    tanqueEncontradoPresion.media = this.soloDosDecimalesConComa(mediaPresion);
                  } else {
                    // Si no se encuentra, añádelo a la lista
                    this.datosEstadisticosPresion.push({
                      nombre: nombreTanquePresion,
                      historico: historicoPresion,
                      maxima: this.soloDosDecimalesConComa(maximoPresion),
                      minima: this.soloDosDecimalesConComa(minimoPresion),
                      media: this.soloDosDecimalesConComa(mediaPresion),
                    });
                  }
                }

                // ESTADÍSTICAS DE CONSUMO
                const historicoConsumo = tanquesDelDispositivoActualConHistorico[j].historicosConsumo;
                if (this.hayAlgunValor(historicoConsumo)) {
                  let nombreTanqueConsumo = 'Tanque ' + tanquesDelDispositivoActualConHistorico[j].custom_num;
                  const diferenciaHorasConsumo = this.calcularDiferenciaHorasConHistorico(tanquesDelDispositivoActualConHistorico[j].historicoFechas);
                  const maximoConsumo = Math.max(...historicoConsumo);
                  const mediaConsumo = historicoConsumo.reduce((acc: any, val: any) => acc + val, 0) / historicoConsumo.length;
                  const sumaTotalConsumo = historicoConsumo.reduce((acc: any, val: any) => acc + val, 0);
                  const litrosHoraConsumo = sumaTotalConsumo / diferenciaHorasConsumo;
                  const litrosDiaConsumo = sumaTotalConsumo / this.diferenciaDias;

                  const tanqueEncontradoConsumo = this.datosEstadisticosConsumo.find((tanque: any) => tanque.nombre === nombreTanqueConsumo);
                  if (tanqueEncontradoConsumo) {
                    // Si se encuentra el tanque, actualiza sus valores
                    tanqueEncontradoConsumo.historico = historicoConsumo;
                    tanqueEncontradoConsumo.maxima = this.soloDosDecimalesConComa(maximoConsumo);
                    tanqueEncontradoConsumo.media = this.soloDosDecimalesConComa(mediaConsumo);
                    tanqueEncontradoConsumo.total = this.soloDosDecimalesConComa(sumaTotalConsumo);
                    tanqueEncontradoConsumo.canhas = this.soloDosDecimalesConComa(parseFloat((sumaTotalConsumo / 0.33).toFixed(0)));
                    tanqueEncontradoConsumo.ritmoCanhas = this.soloDosDecimalesConComa(parseFloat((litrosHoraConsumo / 0.33).toFixed(2)));
                    tanqueEncontradoConsumo.ritmoCanhasDia = this.soloDosDecimalesConComa(parseFloat((litrosDiaConsumo / 0.33).toFixed(2)));
                  } else {
                    // Si no se encuentra, añádelo a la lista
                    this.datosEstadisticosConsumo.push({
                      nombre: nombreTanqueConsumo,
                      historico: historicoConsumo,
                      maxima: this.soloDosDecimalesConComa(maximoConsumo),
                      media: this.soloDosDecimalesConComa(mediaConsumo),
                      total: this.soloDosDecimalesConComa(sumaTotalConsumo),
                      canhas: this.soloDosDecimalesConComa(parseFloat((sumaTotalConsumo / 0.33).toFixed(0))),
                      ritmoCanhas: this.soloDosDecimalesConComa(parseFloat((litrosHoraConsumo / 0.33).toFixed(2))),
                      ritmoCanhasDia: this.soloDosDecimalesConComa(parseFloat((litrosDiaConsumo / 0.33).toFixed(2))),
                      imagen: tanquesDelDispositivoActualConHistorico[j].cerveza.img,
                      imagenURL: this.urlBase + '/uploads/imgs/' + tanquesDelDispositivoActualConHistorico[j].cerveza.img,
                    });
                  }
                }
              }
              // ESTADISICAS TEMPERATURA TODOS
              const todosLosHistoricosT: number[] = [];
              for (const estadistica of this.datosEstadisticosTemperatura) {
                //No tenemos en cuenta la temperatura ambiente
                if (estadistica.nombre !== 'Temp. Ambiente') {
                  todosLosHistoricosT.push(...estadistica.historico);
                }
              }
              const maximoGlobalT = Math.max(...todosLosHistoricosT);
              const minimoGlobalT = Math.min(...todosLosHistoricosT);
              const mediaGlobalT = todosLosHistoricosT.reduce((acc, val) => acc + val, 0) / todosLosHistoricosT.length;
              this.datosEstadisticosTemperaturaTodos = {
                nombre: 'TEMP.',
                historico: todosLosHistoricosT,
                maxima: this.soloDosDecimalesConComa(maximoGlobalT),
                minima: this.soloDosDecimalesConComa(minimoGlobalT),
                media: this.soloDosDecimalesConComa(mediaGlobalT),
              };

              // ESTADISICAS PRESION TODOS
              const todosLosHistoricosP: number[] = [];
              for (const estadistica of this.datosEstadisticosPresion) {
                todosLosHistoricosP.push(...estadistica.historico);
              }
              const maximoGlobalP = Math.max(...todosLosHistoricosP);
              const minimoGlobalP = Math.min(...todosLosHistoricosP);
              const mediaGlobalP = todosLosHistoricosP.reduce((acc, val) => acc + val, 0) / todosLosHistoricosP.length;
              this.datosEstadisticosPresionTodos = {
                nombre: 'PRESIÓN',
                historico: todosLosHistoricosP,
                maxima: this.soloDosDecimalesConComa(maximoGlobalP),
                minima: this.soloDosDecimalesConComa(minimoGlobalP),
                media: this.soloDosDecimalesConComa(mediaGlobalP),
              };

              // ESTADISICAS CONSUMO TODOS
              const todosLosHistoricosC: number[] = [];
              for (const estadistica of this.datosEstadisticosConsumo) {
                todosLosHistoricosC.push(...estadistica.historico);
              }
              // Calcular las horas con el start y el end introducido en el calendario
              const diferenciaHoras = this.calcularDiferenciaHorasConFechas(start, end);
              const maximoGlobalC = Math.max(...todosLosHistoricosC);
              const minimoGlobalC = Math.min(...todosLosHistoricosC);
              const mediaGlobalC = todosLosHistoricosC.reduce((acc, val) => acc + val, 0) / todosLosHistoricosC.length;
              const sumaTotal = todosLosHistoricosC.reduce((acc, val) => acc + val, 0);
              const litrosHora = sumaTotal / diferenciaHoras;
              const litrosDia = sumaTotal / this.diferenciaDias;
              this.datosEstadisticosConsumoTodos = {
                nombre: 'CONSUMO',
                historico: todosLosHistoricosC,
                maxima: this.soloDosDecimalesConComa(maximoGlobalC),
                minima: this.soloDosDecimalesConComa(minimoGlobalC),
                media: this.soloDosDecimalesConComa(mediaGlobalC),
                total: this.soloDosDecimalesConComa(sumaTotal),
                canhas: this.soloDosDecimalesConComa(parseFloat((sumaTotal / 0.33).toFixed(0))),
                ritmoCanhas: this.soloDosDecimalesConComa(parseFloat((litrosHora / 0.33).toFixed(2))),
                ritmoCanhasDia: this.soloDosDecimalesConComa(parseFloat((litrosDia / 0.33).toFixed(2))),
              };
            }
          }
        }
      }, error: err => {
        console.log(err);
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () => { }
    });
  }

  calcularHorasDiaActual(hasta: any) {
    const fechaActual = new Date();
    const fechaHasta = new Date(hasta);
    if (
      fechaHasta.getDate() === fechaActual.getDate() &&
      fechaHasta.getMonth() === fechaActual.getMonth() &&
      fechaHasta.getFullYear() === fechaActual.getFullYear()
    ) {
      const diferenciaTiempo = fechaHasta.getTime() - new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate()).getTime();
      const diferenciaHoras = parseFloat((diferenciaTiempo / (1000 * 60 * 60)).toFixed(2));
      return diferenciaHoras;
    } else {
      return 0;
    }
  }

  calcularDiferenciaHorasConFechas(start: any, end: any) {
    const primeraFecha = new Date(start);
    const ultimaFecha = new Date(end);
    let diferenciaHorasEnDiaActual = 0;
    let diferenciaHoras = 0;
    if (end == this.fechaFormateadaDiaSiguiente && start == this.fechaFormateada) {
      diferenciaHorasEnDiaActual = this.calcularHorasDiaActual(new Date());
      diferenciaHorasEnDiaActual = parseFloat(diferenciaHorasEnDiaActual.toFixed(2));
      return diferenciaHorasEnDiaActual;
    }
    if (end == this.fechaFormateadaDiaSiguiente) {
      diferenciaHorasEnDiaActual = this.calcularHorasDiaActual(new Date());
      diferenciaHorasEnDiaActual = parseFloat(diferenciaHorasEnDiaActual.toFixed(2));
      diferenciaHoras = (+ultimaFecha - +primeraFecha) / (1000 * 60 * 60);
      diferenciaHoras = parseFloat(diferenciaHoras.toFixed(2));
      diferenciaHoras = (diferenciaHoras - 24) + diferenciaHorasEnDiaActual;
    } else {
      diferenciaHoras = (+ultimaFecha - +primeraFecha) / (1000 * 60 * 60);
      diferenciaHoras = parseFloat(diferenciaHoras.toFixed(2));
    }
    return diferenciaHoras;
  }

  calcularDiferenciaHorasConHistorico(historico: any) {
    const primeraFecha = new Date(historico[0]);
    const ultimaFecha = new Date(historico[historico.length - 1]);
    let diferenciaHoras = (+ultimaFecha - +primeraFecha) / (1000 * 60 * 60);
    diferenciaHoras = parseFloat(diferenciaHoras.toFixed(2));
    return diferenciaHoras;
  }

  calcularDiferenciaDiasConHistorico(historico: any) {
    const primeraFecha = new Date(historico[0]);
    const ultimaFecha = new Date(historico[historico.length - 1]);
    const diferenciaMilisegundos = Math.abs(primeraFecha.getTime() - ultimaFecha.getTime());
    this.diferenciaDias = Math.ceil(diferenciaMilisegundos / (1000 * 60 * 60 * 24));
    return this.diferenciaDias;
  }

  hayAlgunValor(lista: any) {
    return lista.length > 0 && lista.some((value: any) => value !== null && !Number.isNaN(value) && value !== undefined && value !== "0.00" && value !== 0)
  }

  obtenerTemperaturaAmbienteYLecturaMasAntiguaDeLaLecturaMasAntigua(historicosEnDispositivo: any[]) {
    if (historicosEnDispositivo.length === 0 || !historicosEnDispositivo[0]?.readers_raw) {
      // Si no hay datos en el día de hoy o el primer elemento no tiene readers_raw, guarda los datos del dispositivo
      this.temperaturaAmbienteActual = this.establecimientoActual.temperaturaAmbiente;
      this.fechaUltimoHistorico = this.establecimientoActual.ultimaLectura;
    } else {
      let lecturaMasAntigua: string | null = null;
      let temperaturaMasAntigua: string | null = null;

      for (let i = 0; i < historicosEnDispositivo.length; i++) {
        const lecturasRaw = historicosEnDispositivo[i]?.readers_raw;

        if (lecturasRaw && lecturasRaw.length > 0) {
          const fechaActual = lecturasRaw[lecturasRaw.length - 1]?.created_at;
          const temperaturaActual = lecturasRaw[lecturasRaw.length - 1]?.field9;

          if (fechaActual && temperaturaActual) {
            if (!lecturaMasAntigua || (fechaActual < lecturaMasAntigua)) {
              lecturaMasAntigua = fechaActual;
              temperaturaMasAntigua = temperaturaActual;
            }
          }
        }
      }

      if (lecturaMasAntigua && temperaturaMasAntigua) {
        this.temperaturaAmbienteActual = temperaturaMasAntigua;
        this.fechaUltimoHistorico = lecturaMasAntigua;
      } else {
        this.temperaturaAmbienteActual = this.establecimientoActual.temperaturaAmbiente;
        this.fechaUltimoHistorico = this.establecimientoActual.ultimaLectura;
      }
    }
    if (this.fechaUltimoHistorico && (this.fechaUltimoHistorico < this.establecimientoActual.ultimaLectura)) {
      this.temperaturaAmbienteActual = this.establecimientoActual.temperaturaAmbiente;
      this.fechaUltimoHistorico = this.establecimientoActual.ultimaLectura;
    }
  }

  calcularConRawDatosDelDiaActual(start: string, end: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const readers_raw: any = [];
      let scale = "5";
      if (!this.escalaDias) {
        scale = "60"
      }

      this.historialRawSubscription = this.deviceService.getMultiHistoricRaw(this.devicesReferences, start, end, scale).subscribe({
        next: (resp) => {
          for (let i = 0; i < resp.length; i++) {
            readers_raw.push(resp[i].readers_raw);
          }
        },
        error: (err) => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
            reject(err);
          } else {
            this.errorMessage = err.error.message;
            reject(err);
          }
        },
        complete: () => {
          resolve(readers_raw);
        }
      });
    });
  }

  resumirHistoricosDelDia() {
    const historicoEstablecimiento: any = [];
    for (let i = 0; i < this.readersRawDiaActual.length; i++) {
      let beer_type_id_1 = null;
      let beer_type_id_2 = null;
      let beer_type_id_3 = null;
      let beer_type_id_4 = null;
      let created_at = null;
      let dev_id = null;
      let field0 = null;
      let field1 = null;
      let field2 = null;
      let field3 = null;
      let field4 = null;
      let field5 = null;
      let field6 = null;
      let field7 = null;
      let field8 = null;
      let field9 = null;
      let field10 = null;
      let field11 = null;
      let field12 = null;
      let field13 = null;
      let field14 = null;
      let field15 = null;
      let field16 = null;
      let field17 = null;
      let field18 = null;
      let field19 = null;
      let field20 = null;
      let field21 = null;
      let field22 = null;
      let field23 = null;
      let field24 = null;
      let field25 = null;
      let field26 = null;
      let field27 = null;
      let field28 = null;
      let id = null;
      let status = null;
      created_at = this.readersRawDiaActual[i][0].created_at; // Primero
      for (let j = 0; j < this.readersRawDiaActual[i].length; j++) {
        beer_type_id_1 = this.readersRawDiaActual[i][j].beer_type_id_1; // Último
        beer_type_id_2 = this.readersRawDiaActual[i][j].beer_type_id_2; // Último
        beer_type_id_3 = this.readersRawDiaActual[i][j].beer_type_id_3; // Último
        beer_type_id_4 = this.readersRawDiaActual[i][j].beer_type_id_4; // Último
        dev_id = this.readersRawDiaActual[i][j].dev_id; // Último
        field0 = this.readersRawDiaActual[i][j].field0; // Último
        field1 = this.readersRawDiaActual[i][j].field1; // Último
        field2 = this.readersRawDiaActual[i][j].field2; // Último
        field3 = (field3 || 0) + this.readersRawDiaActual[i][j].field3; // Media
        field4 = (field4 || 0) + this.readersRawDiaActual[i][j].field4; // Media
        field5 = (field5 || 0) + this.readersRawDiaActual[i][j].field5; // Media
        field6 = (field6 || 0) + this.readersRawDiaActual[i][j].field6; // Media
        field7 = (field7 || 0) + this.readersRawDiaActual[i][j].field7; // Media
        field8 = (field8 || 0) + this.readersRawDiaActual[i][j].field8; // Media
        field9 = (field9 || 0) + this.readersRawDiaActual[i][j].field9; // Media
        field10 = this.readersRawDiaActual[i][j].field10; // Último
        field11 = (field11 || 0) + this.readersRawDiaActual[i][j].field11; // Sumatorio
        field12 = (field12 || 0) + this.readersRawDiaActual[i][j].field12; // Sumatorio
        field13 = (field13 || 0) + this.readersRawDiaActual[i][j].field13; // Sumatorio
        field14 = (field14 || 0) + this.readersRawDiaActual[i][j].field14; // Sumatorio
        field15 = (field15 || 0) + this.readersRawDiaActual[i][j].field15; // Sumatorio
        field16 = (field16 || 0) + this.readersRawDiaActual[i][j].field16; // Sumatorio
        if (field17 === null || this.readersRawDiaActual[i][j].field17 < field17) {
          field17 = this.readersRawDiaActual[i][j].field17; // Minima
        }
        if (field18 === null || this.readersRawDiaActual[i][j].field18 < field18) {
          field18 = this.readersRawDiaActual[i][j].field18; // Minima
        }
        if (field19 === null || this.readersRawDiaActual[i][j].field19 < field19) {
          field19 = this.readersRawDiaActual[i][j].field19; // Minima
        }
        field20 = (field20 || 0) + this.readersRawDiaActual[i][j].field20; // Sumatorio
        field21 = (field21 || 0) + this.readersRawDiaActual[i][j].field21; // Sumatorio
        field22 = (field22 || 0) + this.readersRawDiaActual[i][j].field22; // Sumatorio
        field23 = (field23 || 0) + this.readersRawDiaActual[i][j].field23; // Media
        field24 = (field24 || 0) + this.readersRawDiaActual[i][j].field24; // Media
        if (field25 === null || this.readersRawDiaActual[i][j].field25 < field25) {
          field25 = this.readersRawDiaActual[i][j].field25; // Minima
        }
        field26 = (field26 || 0) + this.readersRawDiaActual[i][j].field26; // Sumatorio
        field27 = (field27 || 0) + this.readersRawDiaActual[i][j].field27; // Sumatorio
        field28 = (field28 || 0) + this.readersRawDiaActual[i][j].field28; // Sumatorio
        id = this.readersRawDiaActual[i][j].id; // Último
        status = this.readersRawDiaActual[i][j].status; // Último
      }

      historicoEstablecimiento.push({
        beer_type_id_1,
        beer_type_id_2,
        beer_type_id_3,
        beer_type_id_4,
        created_at,
        dev_id,
        field0,
        field1,
        field2,
        field3: +(field3 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field4: +(field4 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field5: +(field5 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field6: +(field6 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field7: +(field7 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field8: +(field8 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field9: +(field9 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field10,
        field11: +field11.toFixed(2),
        field12: +field12.toFixed(2),
        field13: +field13.toFixed(2),
        field14: +field14.toFixed(2),
        field15: +field15.toFixed(2),
        field16: +field16.toFixed(2),
        field17,
        field18,
        field19,
        field20: +field20.toFixed(2),
        field21: +field21.toFixed(2),
        field22: +field22.toFixed(2),
        field23: +(field23 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field24: +(field24 / this.readersRawDiaActual[i].length).toFixed(2), // Calcular media y redondear
        field25: +(field25 || 0).toFixed(2), // Redondear (mínima)
        field26,
        field27,
        field28,
        id,
        status,
      });
    }

    return historicoEstablecimiento;
  }

  // ESTABLECIMIENTO COMPLETO HISTORICO

  async loadChartsCompleto(start: string, end: string) {
    this.destroyCharts();
    this.spanGaps = 1250 * 60 * 60;
    this.llamarOptimizada = false;
    this.escalaDias = false;
    this.diaActualIncluido = true;
    this.readersRawDiaActual = [];

    const fecha1 = new Date(start);
    const fecha2 = new Date(end);

    const diferenciaEnMilisegundos = Math.abs(fecha1.getTime() - fecha2.getTime());
    const diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 3600 * 24);
    //A partir de siete dias utilizar la optimizada 
    if (diferenciaEnDias <= 3) {
      this.escalas = [
        { value: '5', viewValue: 'Mínima' },
        { value: '15', viewValue: '15 minutos' },
        { value: '30', viewValue: '30 minutos' },
        { value: '60', viewValue: '60 minutos' },
      ];
    }
    if (diferenciaEnDias > 3) {
      if (!(this.selectedValue === '60' || this.selectedValue === '30' || this.selectedValue === '15')) {
        this.selectedValue = '15';
      }
      this.escalas = [
        { value: '15', viewValue: '15 minutos' },
        { value: '30', viewValue: '30 minutos' },
        { value: '60', viewValue: '60 minutos' },
      ];
    }
    if (diferenciaEnDias > 7) {
      if (!(this.selectedValue === '60' || this.selectedValue === '30')) {
        this.selectedValue = '30';
      }
      this.escalas = [
        { value: '30', viewValue: '30 minutos' },
        { value: '60', viewValue: '60 minutos' },
      ];
    }
    if (diferenciaEnDias >= 15) {
      this.selectedValue = "60";
      this.escalas = [
        { value: '60', viewValue: '60 minutos' },
      ];
    }

    if (diferenciaEnDias >= 15) {
      this.llamarOptimizada = true
    }
    if (diferenciaEnDias > 30) {
      this.escalaDias = true;
      this.spanGaps = 1250 * 60 * 60 * 24 * 1;
    }

    const soloDosDecimalesConComa = (numero: any) => {
      return numero.toLocaleString(this.userServiceData.region, { maximumFractionDigits: 2 });
    };

    // Comprobar si el end es igual a la fecha actual más un día
    const hoy = new Date();
    const mañana = new Date(hoy);
    mañana.setDate(hoy.getDate() + 1);
    if (
      mañana.getFullYear() === fecha2.getFullYear() &&
      mañana.getMonth() === fecha2.getMonth() &&
      mañana.getDate() === fecha2.getDate()
    ) {
      this.diaActualIncluido = true;
    } else {
      this.diaActualIncluido = false;
    }

    if (this.diaActualIncluido && this.llamarOptimizada) {
      const start = hoy.toISOString().split('T')[0];
      this.readersRawDiaActual = await this.calcularConRawDatosDelDiaActual(start, end);
    }

    // VER SI UTILIZAR LA OPTIMIZADA O LA RAW
    let historialObservable;
    if (this.llamarOptimizada) {
      historialObservable = this.deviceService.getMultiHistoricNoScale(this.devicesReferences, start, end);
    } else {
      historialObservable = this.deviceService.getMultiHistoricRaw(this.devicesReferences, start, end, this.selectedValue);
    }
    const nombreCampoLecturas = this.llamarOptimizada ? 'readers' : 'readers_raw';

    this.historialSubscription = historialObservable.subscribe({
      next: (resp) => {
        // Comprobar si hay lecturas en almenos un dispositivo y si es así guardar su tamaño de lecturas orginal
        if (resp.every((item: any) => item[nombreCampoLecturas].length === 0)) {
          this.mensajeNoHayDatos = "(No hay datos disponibles en las fechas seleccionadas)";
          this.graficasDatos = false;
          this.fechaCambiadaGraficasCargardas = true;
        } else {
          for (let i = 0; i < resp.length; i++) {
            for (let j = 0; j < this.dispositivosEnEstablecimientoActual.length; j++) {
              if (resp[i].id == this.dispositivosEnEstablecimientoActual[j].id) {
                this.dispositivosEnEstablecimientoActual[j].tamañoLecturasPrimero = resp[i][nombreCampoLecturas].length;
              }
            }
          }
          // Guardar todos los datos del dispositivo para guardar los tanques
          const dispositivoConLecturas = [];
          for (let i = 0; i < resp.length; i++) {
            let dispositivo = this.devolverDispositivo(resp[i].id);
            dispositivoConLecturas.push({
              ...dispositivo,
              readers_raw: resp[i][nombreCampoLecturas]
            });
          }

          const canvasT: any = document.getElementById('Temperatura');
          const canvasP: any = document.getElementById('Presion');
          const canvasNC: any = document.getElementById('Nivel-Consumo');
          const ctxT = canvasT.getContext('2d');
          const ctxP = canvasP.getContext('2d');
          const ctxNC = canvasNC.getContext('2d');

          const tanques = [];
          for (let i = 0; i < dispositivoConLecturas.length; i++) {
            for (let j = 0; j < this.tanquesEnEstablecimientoActual.length; j++) {
              const tanqueEncontrado = dispositivoConLecturas[i].tanks.find((tank: any) => tank.id == this.tanquesEnEstablecimientoActual[j].id)
              if (tanqueEncontrado) {
                if (this.llamarOptimizada && this.diaActualIncluido && !this.escalaDias) {
                  for (let z = 0; z < this.readersRawDiaActual.length; z++) {
                    if (this.readersRawDiaActual[z][0].dev_id == tanqueEncontrado.device_id) {
                      tanques.push({
                        ...tanqueEncontrado,
                        historicoFechas: this.devolverListaDeHistoricosFechas(dispositivoConLecturas[i].readers_raw.concat(this.readersRawDiaActual[z]), start, end),
                        historicosTemperatura: this.devolverListaDeHistoricosTemperatura(dispositivoConLecturas[i].readers_raw.concat(this.readersRawDiaActual[z]), this.tanquesEnEstablecimientoActual[j]),
                        historicosTemperaturaAmbiente: this.devolverListaDeHistoricosTemperaturaAmbiente(dispositivoConLecturas[i].readers_raw).concat(this.readersRawDiaActual[z]),
                        historicosPresion: this.devolverListaDeHistoricosPresion(dispositivoConLecturas[i].readers_raw.concat(this.readersRawDiaActual[z]), this.tanquesEnEstablecimientoActual[j]),
                        historicosNivel: this.devolverListaDeHistoricosNivel(dispositivoConLecturas[i].readers_raw.concat(this.readersRawDiaActual[z]), this.tanquesEnEstablecimientoActual[j]),
                        historicosConsumo: this.devolverListaDeHistoricosConsumo(dispositivoConLecturas[i].readers_raw.concat(this.readersRawDiaActual[z]), this.tanquesEnEstablecimientoActual[j]),
                      })
                    }
                  }
                } else {
                  if (this.llamarOptimizada && this.diaActualIncluido && this.escalaDias) {
                    const reasumenDelDiaHistoricos = this.resumirHistoricosDelDia();
                    for (let z = 0; z < reasumenDelDiaHistoricos.length; z++) {
                      if (reasumenDelDiaHistoricos[z].dev_id == tanqueEncontrado.device_id) {
                        tanques.push({
                          ...tanqueEncontrado,
                          historicoFechas: this.devolverListaDeHistoricosFechas(dispositivoConLecturas[i].readers_raw.concat(reasumenDelDiaHistoricos[z]), start, end),
                          historicosTemperatura: this.devolverListaDeHistoricosTemperatura(dispositivoConLecturas[i].readers_raw.concat(reasumenDelDiaHistoricos[z]), this.tanquesEnEstablecimientoActual[j]),
                          historicosTemperaturaAmbiente: this.devolverListaDeHistoricosTemperaturaAmbiente(dispositivoConLecturas[i].readers_raw).concat(reasumenDelDiaHistoricos[z]),
                          historicosPresion: this.devolverListaDeHistoricosPresion(dispositivoConLecturas[i].readers_raw.concat(reasumenDelDiaHistoricos[z]), this.tanquesEnEstablecimientoActual[j]),
                          historicosNivel: this.devolverListaDeHistoricosNivel(dispositivoConLecturas[i].readers_raw.concat(reasumenDelDiaHistoricos[z]), this.tanquesEnEstablecimientoActual[j]),
                          historicosConsumo: this.devolverListaDeHistoricosConsumo(dispositivoConLecturas[i].readers_raw.concat(reasumenDelDiaHistoricos[z]), this.tanquesEnEstablecimientoActual[j]),
                        })
                      }
                    }
                  } else {
                    tanques.push({
                      ...tanqueEncontrado,
                      historicoFechas: this.devolverListaDeHistoricosFechas(dispositivoConLecturas[i].readers_raw, start, end),
                      historicosTemperatura: this.devolverListaDeHistoricosTemperatura(dispositivoConLecturas[i].readers_raw, this.tanquesEnEstablecimientoActual[j]),
                      historicosTemperaturaAmbiente: this.devolverListaDeHistoricosTemperaturaAmbiente(dispositivoConLecturas[i].readers_raw),
                      historicosPresion: this.devolverListaDeHistoricosPresion(dispositivoConLecturas[i].readers_raw, this.tanquesEnEstablecimientoActual[j]),
                      historicosNivel: this.devolverListaDeHistoricosNivel(dispositivoConLecturas[i].readers_raw, this.tanquesEnEstablecimientoActual[j]),
                      historicosConsumo: this.devolverListaDeHistoricosConsumo(dispositivoConLecturas[i].readers_raw, this.tanquesEnEstablecimientoActual[j]),
                    })
                  }
                }
                //console.log(tanqueEncontrado, dispositivoConLecturas[i]);
              }
            }
          }
          dispositivoConLecturas.sort((a: any, b: any) => a.dev_label.localeCompare(b.dev_label));
          tanques.sort((a, b) => a.custom_num - b.custom_num);
          this.historicosEnTanques = tanques;
          this.historicosEnDispositivo = dispositivoConLecturas;
          this.obtenerTemperaturaAmbienteYLecturaMasAntiguaDeLaLecturaMasAntigua(this.historicosEnDispositivo);

          // ESTADÍSTICAS

          this.datosEstadisticosTemperatura = []; this.datosEstadisticosPresion = []; this.datosEstadisticosConsumo = [];
          for (let i = 0; i < tanques.length; i++) {
            // ESTADÍSTICAS DE TEMPERATURA
            if (this.hayAlgunValor(tanques[i].historicosTemperatura)) {
              const historico = tanques[i].historicosTemperatura;
              let nombreTanque = 'Tanque ' + tanques[i].custom_num;
              const maximo = Math.max(...historico);
              const minimo = Math.min(...historico);
              const media = historico.reduce((acc: any, val: any) => acc + val, 0) / historico.length;
              this.datosEstadisticosTemperatura.push({
                nombre: nombreTanque,
                historico: historico,
                maxima: this.soloDosDecimalesConComa(maximo),
                minima: this.soloDosDecimalesConComa(minimo),
                media: this.soloDosDecimalesConComa(media),
              });
            }
            // ESTADISTICAS DE PRESION
            if (this.hayAlgunValor(tanques[i].historicosPresion)) {
              const historico = tanques[i].historicosPresion;
              let nombreTanque = 'Tanque ' + tanques[i].custom_num;
              const maximo = Math.max(...historico);
              const minimo = Math.min(...historico);
              const media = historico.reduce((acc: any, val: any) => acc + val, 0) / historico.length;
              this.datosEstadisticosPresion.push({
                nombre: nombreTanque,
                historico: historico,
                maxima: this.soloDosDecimalesConComa(maximo),
                minima: this.soloDosDecimalesConComa(minimo),
                media: this.soloDosDecimalesConComa(media),
              });
            }
            // ESTADISTICAS DE CONSUMO
            if (this.hayAlgunValor(tanques[i].historicosConsumo)) {
              const historico = tanques[i].historicosConsumo;
              let nombreTanque = 'Tanque ' + tanques[i].custom_num;
              const diferenciaHoras = this.calcularDiferenciaHorasConHistorico(tanques[i].historicoFechas);
              const maximo = Math.max(...historico);
              const media = historico.reduce((acc: any, val: any) => acc + val, 0) / historico.length;
              const sumaTotal = historico.reduce((acc: any, val: any) => acc + val, 0);
              const litrosHora = sumaTotal / diferenciaHoras;
              const litrosDia = sumaTotal / this.diferenciaDias;
              this.datosEstadisticosConsumo.push({
                nombre: nombreTanque,
                historico: historico,
                maxima: this.soloDosDecimalesConComa(maximo),
                media: this.soloDosDecimalesConComa(media),
                total: this.soloDosDecimalesConComa(sumaTotal),
                canhas: this.soloDosDecimalesConComa(parseFloat((sumaTotal / 0.33).toFixed(0))),
                ritmoCanhas: this.soloDosDecimalesConComa(parseFloat((litrosHora / 0.33).toFixed(2))),
                ritmoCanhasDia: this.soloDosDecimalesConComa(parseFloat((litrosDia / 0.33).toFixed(2))),
                imagen: this.devolverCerveza(tanques[i].beer_type_id).img,
                imagenURL: this.urlBase + '/uploads/imgs/' + this.devolverCerveza(tanques[i].beer_type_id).img,
              });
            }
          }

          //ESTADISICAS TEMPERATURA TODOS
          const todosLosHistoricosT: number[] = [];
          for (const estadistica of this.datosEstadisticosTemperatura) {
            //No tenemos en cuenta la temperatura ambiente
            if (estadistica.nombre !== 'Temp. Ambiente') {
              todosLosHistoricosT.push(...estadistica.historico);
            }
          }
          const maximoGlobalT = Math.max(...todosLosHistoricosT);
          const minimoGlobalT = Math.min(...todosLosHistoricosT);
          const mediaGlobalT = todosLosHistoricosT.reduce((acc, val) => acc + val, 0) / todosLosHistoricosT.length;
          this.datosEstadisticosTemperaturaTodos = {
            nombre: 'TEMP.',
            historico: todosLosHistoricosT,
            maxima: this.soloDosDecimalesConComa(maximoGlobalT),
            minima: this.soloDosDecimalesConComa(minimoGlobalT),
            media: this.soloDosDecimalesConComa(mediaGlobalT),
          };

          //ESTADISICAS PRESION TODOS
          const todosLosHistoricosP: number[] = [];
          for (const estadistica of this.datosEstadisticosPresion) {
            todosLosHistoricosP.push(...estadistica.historico);
          }
          const maximoGlobalP = Math.max(...todosLosHistoricosP);
          const minimoGlobalP = Math.min(...todosLosHistoricosP);
          const mediaGlobalP = todosLosHistoricosP.reduce((acc, val) => acc + val, 0) / todosLosHistoricosP.length;
          this.datosEstadisticosPresionTodos = {
            nombre: 'PRESIÓN',
            historico: todosLosHistoricosP,
            maxima: this.soloDosDecimalesConComa(maximoGlobalP),
            minima: this.soloDosDecimalesConComa(minimoGlobalP),
            media: this.soloDosDecimalesConComa(mediaGlobalP),
          };

          //ESTADISICAS CONSUMO TODOS
          const todosLosHistoricosC: number[] = [];
          for (const estadistica of this.datosEstadisticosConsumo) {
            todosLosHistoricosC.push(...estadistica.historico);
          }
          // Calcular las horas con el start y el end introducido en el calendario
          const diferenciaHoras = this.calcularDiferenciaHorasConFechas(start, end);
          const maximoGlobalC = Math.max(...todosLosHistoricosC);
          const minimoGlobalC = Math.min(...todosLosHistoricosC);
          const mediaGlobalC = todosLosHistoricosC.reduce((acc, val) => acc + val, 0) / todosLosHistoricosC.length;
          const sumaTotal = todosLosHistoricosC.reduce((acc, val) => acc + val, 0);
          const litrosHora = sumaTotal / diferenciaHoras;
          const litrosDia = sumaTotal / this.diferenciaDias;
          this.datosEstadisticosConsumoTodos = {
            nombre: 'CONSUMO',
            historico: todosLosHistoricosC,
            maxima: this.soloDosDecimalesConComa(maximoGlobalC),
            minima: this.soloDosDecimalesConComa(minimoGlobalC),
            media: this.soloDosDecimalesConComa(mediaGlobalC),
            total: this.soloDosDecimalesConComa(sumaTotal),
            canhas: this.soloDosDecimalesConComa(parseFloat((sumaTotal / 0.33).toFixed(0))),
            ritmoCanhas: this.soloDosDecimalesConComa(parseFloat((litrosHora / 0.33).toFixed(2))),
            ritmoCanhasDia: this.soloDosDecimalesConComa(parseFloat((litrosDia / 0.33).toFixed(2))),
          };

          let datasetsT: any = []; let datasetsP: any = []; let datasetsN: any = []; let datasetsC: any = [];
          for (let i = 0; i < tanques.length; i++) {
            if (tanques[i].historicosTemperatura.length > 0 && tanques[i].historicosTemperatura.some((value: any) => value !== null) && tanques[i].historicosTemperatura.some((value: any) => value !== undefined)) {
              const pointDataTemperatura = [];
              for (let j = 0; j < tanques[i].historicoFechas.length; j++) {
                const date = new Date(tanques[i].historicoFechas[j]);
                pointDataTemperatura.push({
                  x: date,
                  y: tanques[i].historicosTemperatura[j]
                });
              }
              datasetsT.push({
                label: ' Tª tanque ' + tanques[i].custom_num,
                data: pointDataTemperatura,
                borderColor: this.paletaColores[i],
                backgroundColor: this.paletaColores[i],
                borderWidth: 1,
                pointBorderWidth: 10,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: false,
                yAxisID: 'y',
              });
            }
            if (tanques[i].historicosPresion.length > 0 && tanques[i].historicosPresion.some((value: any) => value !== null) && tanques[i].historicosPresion.some((value: any) => value !== undefined)) {
              const pointDataPresion = [];
              for (let j = 0; j < tanques[i].historicoFechas.length; j++) {
                const date = new Date(tanques[i].historicoFechas[j]);
                pointDataPresion.push({
                  x: date,
                  y: tanques[i].historicosPresion[j]
                });
              }
              datasetsP.push({
                label: ' P tanque ' + tanques[i].custom_num,
                data: pointDataPresion,
                borderColor: this.paletaColores[i],
                backgroundColor: this.paletaColores[i],
                borderWidth: 1,
                pointBorderWidth: 10,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: false,
                yAxisID: 'y',
              });
            }
            if (tanques[i].historicosNivel.length > 0 && tanques[i].historicosNivel.some((value: any) => value !== null && value !== "0.00" && value !== undefined && value !== 0)) {
              const pointDataNivel = [];
              for (let j = 0; j < tanques[i].historicoFechas.length; j++) {
                const date = new Date(tanques[i].historicoFechas[j]);
                pointDataNivel.push({
                  x: date,
                  y: tanques[i].historicosNivel[j]
                });
              }
              datasetsN.push({
                label: ' Nivel tanque ' + tanques[i].custom_num,
                data: pointDataNivel,
                borderColor: this.paletaColores[i],
                backgroundColor: this.paletaColores[i],
                borderWidth: 1,
                pointBorderWidth: 10,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: false,
                yAxisID: 'y',
              });
            }
            if (tanques[i].historicosConsumo.length > 0 && tanques[i].historicosConsumo.some((value: any) => value !== null && value !== undefined && value !== 0 && !Number.isNaN(value))) {
              const pointDataConsumo = [];
              for (let j = 0; j < tanques[i].historicoFechas.length; j++) {
                const date = new Date(tanques[i].historicoFechas[j]);
                pointDataConsumo.push({
                  x: date,
                  y: tanques[i].historicosConsumo[j]
                });
              }
              datasetsC.push({
                yAxisID: 'y1',
                hidden: false,
                label: " Consumo tanque " + tanques[i].custom_num,
                borderColor: this.paletaNaranjas[i],
                backgroundColor: this.paletaNaranjas[i],
                pointBorderWidth: 10,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                borderWidth: 1,
                fill: true,
                data: pointDataConsumo,
              });
            }
          }
          // TEMPERATURA AMBIENTE
          for (let i = 0; i < dispositivoConLecturas.length; i++) {
            let temperaturaAmbienteDispositvo: any = [];
            let fechasHistoricoDispositivo: any = [];
            for (let j = 0; j < dispositivoConLecturas[i].readers_raw.length; j++) {
              temperaturaAmbienteDispositvo.push(dispositivoConLecturas[i].readers_raw[j].field9);
              fechasHistoricoDispositivo.push(dispositivoConLecturas[i].readers_raw[j].created_at);
            }
            if (temperaturaAmbienteDispositvo.length > 0 && temperaturaAmbienteDispositvo.some((value: any) => value !== null) && temperaturaAmbienteDispositvo.some((value: any) => value !== undefined)) {
              const pointDataTemperatura = [];
              for (let z = 0; z < fechasHistoricoDispositivo.length; z++) {
                const date = new Date(fechasHistoricoDispositivo[z]);
                pointDataTemperatura.push({
                  x: date,
                  y: temperaturaAmbienteDispositvo[z]
                });
              }
              datasetsT.push({
                label: ' Tª ambiente ' + dispositivoConLecturas[i].dev_label,
                data: pointDataTemperatura,
                borderColor: this.paletaNaranjas[i],
                backgroundColor: this.paletaNaranjas[i],
                borderWidth: 1,
                pointBorderWidth: 10,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 0,
                fill: false,
                yAxisID: 'y',
                hidden: true,
                borderDash: [5, 5],
              });
            }
          }

          // ZOOM OPTIONS
          Chart.register(zoomPlugin);

          // CHART TEMPERATURA
          this.chartT = new Chart(ctxT, {
            type: 'line',
            data: {
              datasets: datasetsT
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: {
                easing: "easeInOutBack"
              },
              spanGaps: this.spanGaps,
              plugins: {
                tooltip: {
                  usePointStyle: true,
                  callbacks: {
                    labelPointStyle: function (context) {
                      return {
                        pointStyle: 'rect',
                        rotation: 0,
                      };
                    },
                    label: function (context) {
                      const label = context.dataset.label || '';
                      const value = soloDosDecimalesConComa(context.parsed.y);
                      return `${label}: ${value}`;
                    },
                  },
                },
                legend: {
                  position: "top",
                  labels: {
                    boxWidth: 20,
                    font: {
                      size: 10
                    }
                  }
                },
                zoom: {
                  pan: {
                    enabled: true,
                    mode: 'x',
                  },
                  zoom: {
                    wheel: {
                      enabled: true,
                    },
                    pinch: {
                      enabled: true
                    },
                    mode: 'x',
                    onZoomComplete({ chart }) {
                      // This update is needed to display up to date zoom level in the title.
                      // Without this, previous zoom level is displayed.
                      // The reason is: title uses the same beforeUpdate hook, and is evaluated before zoom.
                      chart.update('none');
                    }
                  },
                },
              },
              interaction: {
                mode: 'nearest',
                intersect: false,
              },
              scales: {
                y: {
                  beginAtZero: true,
                  position: 'left',
                  ticks: {
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    padding: 3,
                    callback: function (value, index, values) {
                      return soloDosDecimalesConComa(value);
                    },
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: 'Grados Celsius',
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      bottom: 20
                    },
                  },
                },
                x: {
                  type: 'time',
                  time: {
                    // Luxon format string
                    tooltipFormat: 'dd LLLL yyyy HH:mm',
                    parser: 'yyyy-MM-dd HH:mm',
                  },
                  adapters: {
                    date: {
                      locale: es
                    }
                  },
                  ticks: {
                    maxTicksLimit: 20,
                    padding: 25,
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    callback: function (value, index, values) {
                      const date = new Date(value);
                      const day = date.getDate().toString().padStart(2, '0');
                      const month = (date.getMonth() + 1); // Suma 1 porque en JavaScript los meses empiezan en 0
                      const year = date.getFullYear();
                      const hours = date.getHours().toString().padStart(2, '0');
                      const minutes = date.getMinutes().toString().padStart(2, '0');

                      // Cuando el año cambie mostrarlo
                      /*const allDatesHaveSameYear = datasetsT.every((dataset: any) => {
                        if (dataset.data && dataset.data.length > 0) {
                          const datasetYear = new Date(dataset.data[0].x).getFullYear();
                          return datasetYear === year;
                        }
                        return true;
                      });*/

                      /*const unaHoraOMas = datasetsT.every((dataset: any, i: number) => {
                        if (i < datasetsT.length - 1 && dataset.data && dataset.data.length > index && dataset.data.length > index + 1) {
                          const currentDatasetTime = new Date(dataset.data[index].x).getTime();
                          const nextDatasetTime = new Date(dataset.data[index + 1].x).getTime();
                          const timeDifference = (nextDatasetTime - currentDatasetTime) / (1000 * 60); // Diferencia en minutos
                          console.log(timeDifference);
                          // Devuelve true si la diferencia es de 60 minutos o más
                          return timeDifference >= 60;
                        }
                        return true; // Si no hay siguiente dataset, siempre devuelve true
                      });*/

                      /*// Condición para ver si mostrar horas y minutos
                      const displayHour = (unaHoraOMas) ? '' : hours;
                      const displayMinute = (unaHoraOMas) ? '' : minutes;
                      const hourMinutesSeparator = (unaHoraOMas) ? '' : ':';*/

                      // Obtener el año del primer y último elemento del primer dataset
                      if (datasetsT && datasetsT.length > 0 && datasetsT[0].data && datasetsT[0].data.length > 0) {
                        const firstYear = datasetsT[0].data[0].x.getFullYear();
                        const lastYear = datasetsT[0].data[datasetsT[0].data.length - 1].x.getFullYear();

                        // Condición para omitir el año si todas las fechas tienen el mismo año
                        const displayYear = (firstYear == lastYear) ? '' : year;
                        const yearSeparator = (firstYear == lastYear) ? '' : '/';

                        return `${day}/${month}${yearSeparator}${displayYear} ${hours}:${minutes}`;
                      }

                      return `${day}/${month}/${year} ${hours}:${minutes}`;
                    },
                    //autoSkip: false, ->Mostrar todo el contenido de las labels en el eje x
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: this.stringTitulosTiempo,
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      top: 10
                    }
                  },
                }
              }
            }
          });

          // CHART PRESION
          this.chartP = new Chart(ctxP, {
            type: 'line',
            data: {
              datasets: datasetsP
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: {
                easing: "easeInOutBack"
              },
              spanGaps: this.spanGaps,
              plugins: {
                tooltip: {
                  usePointStyle: true,
                  callbacks: {
                    labelPointStyle: function (context) {
                      return {
                        pointStyle: 'rect',
                        rotation: 0,
                      };
                    },
                    label: function (context) {
                      const label = context.dataset.label || '';
                      const value = soloDosDecimalesConComa(context.parsed.y);
                      return `${label}: ${value}`;
                    },
                  }
                },
                legend: {
                  position: "top",
                  labels: {
                    boxWidth: 20,
                    font: {
                      size: 10
                    }
                  }
                },
                zoom: {
                  pan: {
                    enabled: true,
                    mode: 'x',
                  },
                  zoom: {
                    wheel: {
                      enabled: true,
                    },
                    pinch: {
                      enabled: true
                    },
                    mode: 'x',
                  }
                }
              },
              interaction: {
                mode: 'nearest',
                intersect: false
              },
              scales: {
                y: {
                  beginAtZero: true,
                  position: 'left',
                  ticks: {
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    padding: 3,
                    callback: function (value, index, values) {
                      return soloDosDecimalesConComa(value);
                    },
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: 'Bares',
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      bottom: 20
                    },
                  },
                },
                x: {
                  type: 'time',
                  time: {
                    // Luxon format string
                    tooltipFormat: 'dd LLLL yyyy HH:mm',
                    parser: 'yyyy-MM-dd HH:mm',
                  },
                  adapters: {
                    date: {
                      locale: es
                    }
                  },
                  ticks: {
                    maxTicksLimit: 20,
                    padding: 25,
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    callback: function (value, index, values) {
                      const date = new Date(value);
                      const day = date.getDate().toString().padStart(2, '0');
                      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Suma 1 porque en JavaScript los meses empiezan en 0
                      const year = date.getFullYear();
                      const hours = date.getHours().toString().padStart(2, '0');
                      const minutes = date.getMinutes().toString().padStart(2, '0');

                      // Obtener el año del primer y último elemento del primer dataset
                      if (datasetsP && datasetsP.length > 0 && datasetsP[0].data && datasetsP[0].data.length > 0) {
                        const firstYear = datasetsP[0].data[0].x.getFullYear();
                        const lastYear = datasetsP[0].data[datasetsP[0].data.length - 1].x.getFullYear();

                        // Condición para omitir el año si todas las fechas tienen el mismo año
                        const displayYear = (firstYear == lastYear) ? '' : year;
                        const yearSeparator = (firstYear == lastYear) ? '' : '/';

                        return `${day}/${month}${yearSeparator}${displayYear} ${hours}:${minutes}`;
                      }

                      return `${day}/${month}/${year} ${hours}:${minutes}`;
                    },
                    //autoSkip: false,
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: this.stringTitulosTiempo,
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      top: 10
                    }
                  },
                }
              }
            }
          });
          // CHART NIVEL/CONSUMO
          this.chartNC = new Chart(ctxNC, {
            type: 'line',
            data: {
              datasets: [
                // Nivel (línea)
                ...datasetsN.map((dataset: any) => ({
                  ...dataset,
                  type: 'line',
                  order: 1,
                })),
                // Consumo (barras)
                ...datasetsC.map((dataset: any) => ({
                  ...dataset,
                  type: 'bar',
                  order: 2,
                  barThickness: 1,
                }))
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: {
                easing: "easeInOutBack"
              },
              spanGaps: this.spanGaps,
              plugins: {
                tooltip: {
                  usePointStyle: true,
                  callbacks: {
                    labelPointStyle: function (context) {
                      return {
                        pointStyle: 'rect',
                        rotation: 0,
                      };
                    },
                    label: function (context) {
                      const label = context.dataset.label || '';
                      const value = soloDosDecimalesConComa(context.parsed.y);
                      return `${label}: ${value}`;
                    },
                  }
                },
                legend: {
                  position: "top",
                  labels: {
                    boxWidth: 20,
                    font: {
                      size: 10
                    }
                  }
                },
                zoom: {
                  pan: {
                    enabled: true,
                    mode: 'x',
                  },
                  zoom: {
                    wheel: {
                      enabled: true,
                    },
                    pinch: {
                      enabled: true
                    },
                    mode: 'x',
                  }
                }
              },
              interaction: {
                mode: 'nearest',
                intersect: false
              },
              scales: {
                y: {
                  beginAtZero: true,
                  position: 'left',
                  ticks: {
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    padding: 10,
                    callback: function (value, index, values) {
                      return soloDosDecimalesConComa(value);
                    },
                  },
                  grid: {
                    display: false,
                    drawTicks: false,
                  },
                  title: {
                    display: true,
                    text: 'Nivel (Litros)',
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      bottom: 20
                    },
                  },
                },
                y1: { // Segundo eje Y
                  beginAtZero: true,
                  position: 'right',
                  ticks: {
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold',
                    },
                    padding: 3,
                    callback: function (value, index, values) {
                      return soloDosDecimalesConComa(value);
                    },
                  },
                  grid: {
                    display: false,
                  },
                  title: {
                    display: true,
                    text: 'Consumo (Litros)',
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      bottom: 20
                    }
                  }
                },
                x: {
                  type: 'time',
                  time: {
                    // Luxon format string
                    tooltipFormat: 'dd LLLL yyyy HH:mm',
                    parser: 'yyyy-MM-dd HH:mm',
                  },
                  adapters: {
                    date: {
                      locale: es
                    }
                  },
                  ticks: {
                    maxTicksLimit: 20,
                    padding: 25,
                    color: "rgba(0,0,0,0.7)",
                    font: {
                      size: 11,
                      weight: 'bold'
                    },
                    callback: function (value, index, values) {
                      const date = new Date(value);
                      const day = date.getDate().toString().padStart(2, '0');
                      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Suma 1 porque en JavaScript los meses empiezan en 0
                      const year = date.getFullYear();
                      const hours = date.getHours().toString().padStart(2, '0');
                      const minutes = date.getMinutes().toString().padStart(2, '0');

                      // Obtener el año del primer y último elemento del primer dataset
                      if (datasetsN && datasetsN.length > 0 && datasetsN[0].data && datasetsN[0].data.length > 0) {
                        const firstYear = datasetsN[0].data[0].x.getFullYear();
                        const lastYear = datasetsN[0].data[datasetsN[0].data.length - 1].x.getFullYear();

                        // Condición para omitir el año si todas las fechas tienen el mismo año
                        const displayYear = (firstYear == lastYear) ? '' : year;
                        const yearSeparator = (firstYear == lastYear) ? '' : '/';

                        return `${day}/${month}${yearSeparator}${displayYear} ${hours}:${minutes}`;
                      }

                      return `${day}/${month}/${year} ${hours}:${minutes}`;
                    },
                    //autoSkip: false,
                  },
                  grid: {
                    display: false
                  },
                  title: {
                    display: true,
                    text: this.stringTitulosTiempo,
                    font: {
                      size: 13,
                      weight: 'bold'
                    },
                    padding: {
                      top: 10
                    }
                  },
                }
              }
            }
          });
          //Guardar en una matriz para luego eliminarlos antes de cargar las nuevas
          this.charts.push(this.chartT);
          this.charts.push(this.chartP);
          this.charts.push(this.chartNC);
        }
      }, error: err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () => {
        this.fechaCambiadaGraficasCargardas = true;
      }
    })
  }

  resetZoomT() {
    if (this.chartT) {
      this.chartT.resetZoom();
    }
  }
  resetZoomP() {
    if (this.chartP) {
      this.chartP.resetZoom();
    }
  }
  resetZoomNC() {
    if (this.chartNC) {
      this.chartNC.resetZoom();
    }
  }

  devolverListaDeHistoricosFechas(historicos: any, start: string, end: string) {
    let listaConFechas = [];

    //Calcular la diferencia en días entre la ultima y la primera lectura
    /*const fechaOriginal = new Date(start);
    const fechaSumada = new Date(fechaOriginal);
    fechaSumada.setDate(fechaOriginal.getDate() + 1);
    let variosDiasHistorico = false;
    //Si se muestra más de un día
    if(end > fechaSumada.toISOString().split("T")[0]){
      variosDiasHistorico = true;
    }
    for(let i=0; i<historicos.length; i++){
      const createdAt = historicos[i].created_at;
      this.stringTitulosTiempo = "Fecha (Año-Mes-Día HH:mm)";
      if(!variosDiasHistorico){
        const hora = this.conseguirHoraEnFecha(createdAt);
        this.stringTitulosTiempo = "Fecha (HH:mm)";
        listaConFechas.push(hora);
      } else{
        listaConFechas.push(createdAt);
        let listaTiemposSinSegundos: any[] = listaConFechas.map(tiempoConSegundos => {
          // Dividir la cadena en fecha y hora
          let [fecha, hora] = tiempoConSegundos.split(' ');
          // Dividir la hora en partes usando el caracter ':'
          let partesHora: string[] = hora.split(':');
          // Unir las partes de hora y minutos para formar la nueva cadena sin segundos
          let nuevaHora: string = partesHora[0] + ':' + partesHora[1];
          // Construir la cadena final
          return fecha + ' ' + nuevaHora;
        });
        listaConFechas = listaTiemposSinSegundos;
      }
    }
    let endDate = new Date(end);
    endDate.setDate(endDate.getDate() - 1);
    listaConFechas = this.quitarAnioYMesSiMismoAnioYMes(listaConFechas, start, endDate.toISOString().split('T')[0]);*/

    for (let i = 0; i < historicos.length; i++) {
      const createdAt = historicos[i].created_at;
      listaConFechas.push(createdAt);
    }

    return listaConFechas;
  }

  devolverListaDeHistoricosTemperaturaAmbiente(historicos: any) {
    const listaConTemperaturaAmbiente = [];

    for (let i = 0; i < historicos.length; i++) {
      listaConTemperaturaAmbiente.push(historicos[i].field9);
    }

    return listaConTemperaturaAmbiente;
  }

  devolverListaDeHistoricosTemperatura(historicos: any, tanque: any) {
    const listaConTemperaturas = [];
    switch (tanque.slot) {
      case 1:
        for (let i = 0; i < historicos.length; i++) {
          listaConTemperaturas.push(historicos[i].field6);
        }
        break;
      case 2:
        for (let i = 0; i < historicos.length; i++) {
          listaConTemperaturas.push(historicos[i].field7);
        }
        break;
      case 3:
        for (let i = 0; i < historicos.length; i++) {
          listaConTemperaturas.push(historicos[i].field8);
        }
        break;
      default:
        for (let i = 0; i < historicos.length; i++) {
          listaConTemperaturas.push(historicos[i].field24);
        }
        break;
    }
    return listaConTemperaturas;
  }

  devolverListaDeHistoricosPresion(historicos: any, tanque: any) {
    const listaConPresion = [];
    switch (tanque.slot) {
      case 1:
        for (let i = 0; i < historicos.length; i++) {
          listaConPresion.push(historicos[i].field3);
        }
        break;
      case 2:
        for (let i = 0; i < historicos.length; i++) {
          listaConPresion.push(historicos[i].field4);
        }
        break;
      case 3:
        for (let i = 0; i < historicos.length; i++) {
          listaConPresion.push(historicos[i].field5);
        }
        break;
      default:
        for (let i = 0; i < historicos.length; i++) {
          listaConPresion.push(historicos[i].field23);
        }
        break;
    }
    return listaConPresion;
  }

  devolverListaDeHistoricosNivel(historicos: any, tanque: any) {
    const listaConNivel = [];
    switch (tanque.slot) {
      case 1:
        for (let i = 0; i < historicos.length; i++) {
          listaConNivel.push(historicos[i].field17);
        }
        break;
      case 2:
        for (let i = 0; i < historicos.length; i++) {
          listaConNivel.push(historicos[i].field18);
        }
        break;
      case 3:
        for (let i = 0; i < historicos.length; i++) {
          listaConNivel.push(historicos[i].field19);
        }
        break;
      default:
        for (let i = 0; i < historicos.length; i++) {
          listaConNivel.push(historicos[i].field25);
        }
        break;
    }
    return listaConNivel;
  }

  devolverListaDeHistoricosConsumo(historicos: any, tanque: any) {
    const listaConConsumos = [];
    switch (tanque.slot) {
      case 1:
        for (let i = 0; i < historicos.length; i++) {
          listaConConsumos.push((historicos[i].field11) + (historicos[i].field12) + (historicos[i].field20));
        }
        break;
      case 2:
        for (let i = 0; i < historicos.length; i++) {
          listaConConsumos.push((historicos[i].field13) + (historicos[i].field14) + (historicos[i].field21));
        }
        break;
      case 3:
        for (let i = 0; i < historicos.length; i++) {
          listaConConsumos.push((historicos[i].field15) + (historicos[i].field16) + (historicos[i].field22));
        }
        break;
      default:
        for (let i = 0; i < historicos.length; i++) {
          listaConConsumos.push((historicos[i].field26) + (historicos[i].field27) + (historicos[i].field28));
        }
        break;
    }
    return listaConConsumos;
  }

  calcularTodosLosEstablecimiento() {
    return new Promise<void>((resolve, reject) => {
      this.establecimientosSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
        next: resp => {
          this.establecimientos = resp;
        }, error: err => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete: () => {
          resolve();
        }
      });
    })
  }

  cargarPedidosyRecargas() {
    //const start = "2015-01-01"
    return new Promise<void>((resolve, reject) => {
      const currentDate = new Date();
      const start = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      // Coger los pedidos desde el día de hoy a un año atras
      start.setDate(currentDate.getDate() - 365);
      console.log(start.toISOString().slice(0, 10))
      this.pedidosSubscription = this.deviceService.getPedidos(start.toISOString().slice(0, 10), currentDate.toISOString().slice(0, 10)).subscribe({
        next: resp => {
          this.pedidos = resp.orders;
          this.pedidos.sort((a: any, b: any) => a.created_at.localeCompare(b.created_at));
        }, error: err => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete: () => {
          const establecimientosIDs: any = [];
          for (let x = 0; x < this.establecimientos.length; x++) {
            establecimientosIDs.push(this.establecimientos[x].id);
          }
          const recargasData = new FormData();
          recargasData.append('establishments', JSON.stringify(establecimientosIDs));
          this.recargasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
            next: resp => {
              this.recargas = resp.charges;
              this.recargas.sort((a: any, b: any) => a.created_at.localeCompare(b.created_at));
            }, error: err => {
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
              reject(err);
            }, complete: () => {
              resolve();
            }
          });
        }
      });
    })
  }

  async solicitarRecarga(tank_id: number, establishment_id: number) {
    this.waitAfterSave = false;
    let hacerPedido: boolean = false;
    let mensajeDeErrorPersonalizado = "Ya existe el pedido";

    await this.calcularTodosLosEstablecimiento();
    await this.cargarPedidosyRecargas()

    // Comprobar que si el pedido ya se ha realizado y no se ha recibido ninguna recarga
    const pedidosConTanqueID = this.pedidos.filter((pedido: any) => pedido.tank_id == tank_id);
    const pedidoMasAntiguo = pedidosConTanqueID[pedidosConTanqueID.length - 1];

    const recargasConTanqueID = this.recargas.filter((recarga: any) => recarga.tank_id == tank_id);
    const recargaMasAntigua = recargasConTanqueID[recargasConTanqueID.length - 1];

    if (recargasConTanqueID.length == 0 && pedidosConTanqueID.length < 0) {
      hacerPedido = false;
    }
    if (recargasConTanqueID.length > 0) {
      if (pedidoMasAntiguo) {
        if (pedidoMasAntiguo.created_at <= recargaMasAntigua.created_at) {
          hacerPedido = true;
        } else {
          hacerPedido = false;
        }
      } else {
        hacerPedido = true;
      }
    }

    if (!hacerPedido) {
      if (!this.waitAfterSave) {
        this.waitAfterSave = true;
      }
      setTimeout(() => {
        this.waitAfterSave = false;
      }, 4500)
      this.toastr.error(mensajeDeErrorPersonalizado, 'Error', {
        timeOut: 4500,
        progressBar: true,
        titleClass: 'toast-family-font'
      });
    } else {
      const pedido = new FormData();
      pedido.append('_method', "PUT");
      pedido.append('establishment_id', establishment_id.toString());
      pedido.append('tank_id', tank_id.toString());

      this.agregarPedidoSubscription = this.deviceService.createPedido(pedido).subscribe({
        next: resp => {
          console.log(resp);
        }, error: err => {
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
          }
          setTimeout(() => {
            this.waitAfterSave = false;
          }, 3500)
          this.toastr.error("Acción no permitida", 'Error', {
            timeOut: 3500,
            progressBar: true,
            titleClass: 'toast-family-font'
          });
        }, complete: () => {
          this.toastr.success('¡Pedido solicitado!', 'Éxito', {
            timeOut: 3500,
            progressBar: true,
            titleClass: 'toast-family-font'
          });
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
          }
          setTimeout(() => {
            this.waitAfterSave = false;
          }, 3500)
        }
      });
    }
  }
}
